import { Utility, FileModel, ServiceProvider, AthenaeumConstants, BaseLocalizer } from '@reapptor-apps/reapptor-toolkit';
import React from 'react';
import { Dictionary } from 'typescript-collections';
import { Mutex } from 'async-mutex';
import queryString from 'query-string';
import $ from 'jquery';

var CameraType;
(function (CameraType) {
  /**
   * Front camera, capture="user"
   */
  CameraType[CameraType["UserFacingCamera"] = 0] = "UserFacingCamera";
  /**
   * Back camera, capture="environment"
   */
  CameraType[CameraType["OutwardFacingCamera"] = 1] = "OutwardFacingCamera";
})(CameraType || (CameraType = {}));
var WebApplicationType;
(function (WebApplicationType) {
  WebApplicationType[WebApplicationType["DesktopBrowser"] = 0] = "DesktopBrowser";
  WebApplicationType[WebApplicationType["MobileBrowser"] = 1] = "MobileBrowser";
  WebApplicationType[WebApplicationType["MobileApp"] = 2] = "MobileApp";
  WebApplicationType[WebApplicationType["PwaApp"] = 3] = "PwaApp";
})(WebApplicationType || (WebApplicationType = {}));
var Align;
(function (Align) {
  Align[Align["Bottom"] = 0] = "Bottom";
  Align[Align["Top"] = 1] = "Top";
})(Align || (Align = {}));
var Justify;
(function (Justify) {
  Justify[Justify["Left"] = 0] = "Left";
  Justify[Justify["Right"] = 1] = "Right";
})(Justify || (Justify = {}));
var TextAlign;
(function (TextAlign) {
  TextAlign[TextAlign["Left"] = 0] = "Left";
  TextAlign[TextAlign["Center"] = 1] = "Center";
  TextAlign[TextAlign["Right"] = 2] = "Right";
})(TextAlign || (TextAlign = {}));
var VerticalAlign;
(function (VerticalAlign) {
  VerticalAlign[VerticalAlign["Top"] = 0] = "Top";
  VerticalAlign[VerticalAlign["Middle"] = 1] = "Middle";
  VerticalAlign[VerticalAlign["Bottom"] = 2] = "Bottom";
})(VerticalAlign || (VerticalAlign = {}));
var AlertType;
(function (AlertType) {
  AlertType[AlertType["Success"] = 0] = "Success";
  AlertType[AlertType["Warning"] = 1] = "Warning";
  AlertType[AlertType["Info"] = 2] = "Info";
  AlertType[AlertType["Danger"] = 3] = "Danger";
  AlertType[AlertType["Primary"] = 4] = "Primary";
  AlertType[AlertType["Secondary"] = 5] = "Secondary";
  AlertType[AlertType["Light"] = 6] = "Light";
  AlertType[AlertType["Dark"] = 7] = "Dark";
})(AlertType || (AlertType = {}));
/**
 * Specifies identifiers to indicate the return value of a dialog box.
 */
var DialogResult;
(function (DialogResult) {
  /**
   * Nothing is returned from the dialog box. This means that the modal dialog continues running.
   */
  DialogResult[DialogResult["None"] = 0] = "None";
  /**
   * The dialog box return value is OK (usually sent from a button labeled OK).
   */
  DialogResult[DialogResult["OK"] = 1] = "OK";
  /**
   * The dialog box return value is Cancel (usually sent from a button labeled Cancel).
   */
  DialogResult[DialogResult["Cancel"] = 2] = "Cancel";
  /**
   * The dialog box return value is Abort (usually sent from a button labeled Abort).
   */
  DialogResult[DialogResult["Abort"] = 3] = "Abort";
  /**
   * The dialog box return value is Retry (usually sent from a button labeled Retry).
   */
  DialogResult[DialogResult["Retry"] = 4] = "Retry";
  /**
   * The dialog box return value is Ignore (usually sent from a button labeled Ignore).
   */
  DialogResult[DialogResult["Ignore"] = 5] = "Ignore";
  /**
   * The dialog box return value is Yes (usually sent from a button labeled Yes).
   */
  DialogResult[DialogResult["Yes"] = 6] = "Yes";
  /**
   * The dialog box return value is No (usually sent from a button labeled No).
   */
  DialogResult[DialogResult["No"] = 7] = "No";
})(DialogResult || (DialogResult = {}));
/**
 * Specifies constants defining which buttons to display on a System.Windows.Forms.MessageBox.
 */
var MessageBoxButtons;
(function (MessageBoxButtons) {
  /**
   * The message box contains an OK button.
   */
  MessageBoxButtons[MessageBoxButtons["OK"] = 0] = "OK";
  /**
   * The message box contains OK and Cancel buttons.
   */
  MessageBoxButtons[MessageBoxButtons["OKCancel"] = 1] = "OKCancel";
  /**
   * The message box contains Abort, Retry, and Ignore buttons.
   */
  MessageBoxButtons[MessageBoxButtons["AbortRetryIgnore"] = 2] = "AbortRetryIgnore";
  /**
   * The message box contains Yes, No, and Cancel buttons.
   */
  MessageBoxButtons[MessageBoxButtons["YesNoCancel"] = 3] = "YesNoCancel";
  /**
   * The message box contains Yes and No buttons.
   */
  MessageBoxButtons[MessageBoxButtons["YesNo"] = 4] = "YesNo";
  /**
   * The message box contains Retry and Cancel buttons.
   */
  MessageBoxButtons[MessageBoxButtons["RetryCancel"] = 5] = "RetryCancel";
  MessageBoxButtons[MessageBoxButtons["Custom"] = 6] = "Custom";
})(MessageBoxButtons || (MessageBoxButtons = {}));
/**
 * Specifies constants defining which information to display.
 */
var MessageBoxIcon;
(function (MessageBoxIcon) {
  /**
   * The message box contain no symbols.
   */
  MessageBoxIcon[MessageBoxIcon["None"] = 0] = "None";
  /**
   * The message box contains a symbol consisting of a white X in a circle with a red background.
   */
  MessageBoxIcon[MessageBoxIcon["Hand"] = 1] = "Hand";
  /**
   * The message box contains a symbol consisting of white X in a circle with a red background.
   */
  MessageBoxIcon[MessageBoxIcon["Stop"] = 2] = "Stop";
  /**
   * The message box contains a symbol consisting of white X in a circle with a red background.
   */
  MessageBoxIcon[MessageBoxIcon["Error"] = 3] = "Error";
  /**
   * The message box contains a symbol consisting of a question mark in a circle.
    * The question-mark message icon is no longer recommended because it does not clearly
    * represent a specific type of message and because the phrasing of a message as
    * a question could apply to any message type. In addition, users can confuse the
    * message symbol question mark with Help information. Therefore, do not use this
    * question mark message symbol in your message boxes. The system continues to support
    * its inclusion only for backward compatibility.
   */
  MessageBoxIcon[MessageBoxIcon["Question"] = 4] = "Question";
  /**
   * The message box contains a symbol consisting of an exclamation point in a triangle with a yellow background.
   */
  MessageBoxIcon[MessageBoxIcon["Exclamation"] = 5] = "Exclamation";
  /**
   * The message box contains a symbol consisting of an exclamation point in a triangle with a yellow background.
   */
  MessageBoxIcon[MessageBoxIcon["Warning"] = 6] = "Warning";
  /**
   * The message box contains a symbol consisting of a lowercase letter i in a circle.
   */
  MessageBoxIcon[MessageBoxIcon["Asterisk"] = 7] = "Asterisk";
  /**
   * The message box contains a symbol consisting of a lowercase letter i in a circle.
   */
  MessageBoxIcon[MessageBoxIcon["Information"] = 8] = "Information";
})(MessageBoxIcon || (MessageBoxIcon = {}));
var SwipeDirection;
(function (SwipeDirection) {
  SwipeDirection[SwipeDirection["Left"] = 0] = "Left";
  SwipeDirection[SwipeDirection["Right"] = 1] = "Right";
  SwipeDirection[SwipeDirection["Up"] = 2] = "Up";
  SwipeDirection[SwipeDirection["Down"] = 3] = "Down";
})(SwipeDirection || (SwipeDirection = {}));
var LinkTarget;
(function (LinkTarget) {
  /**
   * Load in a new window
   */
  LinkTarget["Blank"] = "_blank";
  /**
   * Load in the same frame as it was clicked
   */
  LinkTarget["Self"] = "_self";
})(LinkTarget || (LinkTarget = {}));
var BaseInputType;
(function (BaseInputType) {
  BaseInputType["Text"] = "text";
  BaseInputType["Email"] = "email";
  BaseInputType["Url"] = "url";
  BaseInputType["Password"] = "password";
  BaseInputType["Number"] = "number";
  BaseInputType["Currency"] = "currency";
  BaseInputType["TextArea"] = "textarea";
  BaseInputType["Dropdown"] = "dropdown";
  BaseInputType["Checkbox"] = "checkbox";
  BaseInputType["File"] = "file";
})(BaseInputType || (BaseInputType = {}));
var InputValidationRule;
(function (InputValidationRule) {
  /**
   * Default empty matcher
   */
  InputValidationRule["Default"] = "";
  /**
   * Value must be a proper email form
   */
  InputValidationRule["Email"] = "^.+@.+\\..+$";
  /**
   * Value must be a proper url form, no port number or localhost supported
   */
  InputValidationRule["Url"] = "(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})";
  /**
   * Value must contain at least 1 lowercase, 1 uppercase character and 1 special character
   * Value must be 8 characters or longer
   */
  InputValidationRule["Password"] = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9 :])(?=.{8,})";
  /**
   * Generalish phone number validation. Requires 5-15 numbers separated by arbtirary amount of separators.
   *
   * Example matched numbers (source: https://stdcxx.apache.org/doc/stdlibug/26-1.html and self generated):
   *
   * 754-3010
   *
   * (541) 754-3010
   *
   * +1-541-754-3010
   *
   * 1-541-754-3010
   *
   * 001-541-754-3010
   *
   * 191 541 754 3010
   *
   * 636-48018
   *
   * (089) / 636-48018
   *
   * +49-89-636-48018
   *
   * 19-49-89-636-48018
   *
   * +358 123 456 789
   *
   * 044 440 040 045
   *
   * 020202
   *
   * 02 02 02
   *
   * 020 202
   */
  InputValidationRule["Phone"] = "^\\+?([- ()/]*[0-9][-()/]*){5,15}$";
})(InputValidationRule || (InputValidationRule = {}));
var PasswordValidationRule;
(function (PasswordValidationRule) {
  PasswordValidationRule["LowerCaseCharacter"] = "^(?=.*[a-z])";
  PasswordValidationRule["UpperCaseCharacter"] = "^(?=.*[A-Z])";
  PasswordValidationRule["NumberCharacter"] = "^(?=.*[0-9])";
  PasswordValidationRule["SpecialCharacter"] = "^(?=.*[^a-zA-Z0-9 :])";
})(PasswordValidationRule || (PasswordValidationRule = {}));
var PasswordValidationError;
(function (PasswordValidationError) {
  /**
   * One lowercase ('a'-'z') characters.
   */
  PasswordValidationError[PasswordValidationError["Lowercase"] = 0] = "Lowercase";
  /**
   * One uppercase ('A'-'Z') characters.
   */
  PasswordValidationError[PasswordValidationError["Uppercase"] = 1] = "Uppercase";
  /**
   * One non alphanumeric characters.
   */
  PasswordValidationError[PasswordValidationError["NonAlphabetic"] = 2] = "NonAlphabetic";
  /**
   * Min 6 and at max 100 characters long.
   */
  PasswordValidationError[PasswordValidationError["Length"] = 3] = "Length";
})(PasswordValidationError || (PasswordValidationError = {}));
var ActionType;
(function (ActionType) {
  ActionType[ActionType["Default"] = 0] = "Default";
  /**
   * "text-success"
   */
  ActionType[ActionType["Create"] = 1] = "Create";
  ActionType[ActionType["Edit"] = 2] = "Edit";
  /**
   * red
   */
  ActionType[ActionType["Delete"] = 3] = "Delete";
  /**
   * grey
   */
  ActionType[ActionType["Muted"] = 4] = "Muted";
  /**
   * "text-light"
   */
  ActionType[ActionType["Light"] = 5] = "Light";
  /**
   * "text-secondary"
   */
  ActionType[ActionType["Secondary"] = 6] = "Secondary";
  /**
   * cyan
   */
  ActionType[ActionType["Info"] = 7] = "Info";
  ActionType[ActionType["Grey"] = 8] = "Grey";
  ActionType[ActionType["Blue"] = 9] = "Blue";
})(ActionType || (ActionType = {}));
var BackButtonVisibility;
(function (BackButtonVisibility) {
  BackButtonVisibility[BackButtonVisibility["Visible"] = 0] = "Visible";
  BackButtonVisibility[BackButtonVisibility["Hidden"] = 1] = "Hidden";
  BackButtonVisibility[BackButtonVisibility["Desktop"] = 2] = "Desktop";
  BackButtonVisibility[BackButtonVisibility["Mobile"] = 3] = "Mobile";
})(BackButtonVisibility || (BackButtonVisibility = {}));
var TokenType;
(function (TokenType) {
  TokenType[TokenType["Service"] = 0] = "Service";
  TokenType[TokenType["Mobile"] = 1] = "Mobile";
  TokenType[TokenType["Email"] = 2] = "Email";
  TokenType[TokenType["Login"] = 3] = "Login";
})(TokenType || (TokenType = {}));

class CountryInfo {
  constructor() {
    this.name = "";
    this.englishName = "";
    this.code = "";
    this.phoneCode = 0;
    this.culture = "";
    this.aliases = [];
    this.isCountryInfo = true;
  }
}

class AlertModel {
  constructor(message = "", alertType = AlertType.Success, autoClose = false, flyout = false, autoCloseDelay, route = null) {
    /**
     * Message displayed in the alert.
     *
     * @default ""
     */
    this.message = "";
    /**
     * @default null
     */
    this.messageParams = null;
    /**
     * Type of the alert. Mainly affects coloring.
     *
     * @default {@link AlertType.Success}
     */
    this.alertType = AlertType.Success;
    /**
     * Should the alert be user dismissable.
     *
     * @default true
     */
    this.dismissible = true;
    /**
     * Should the alert be automatically closed after {@link autoCloseDelay} milliseconds.
     *
     * @default false
     */
    this.autoClose = false;
    /**
     * After how many milliseconds should the alert be closed if {@link autoClose} is set to true.
     *
     * @default 5000
     */
    this.autoCloseDelay = null;
    /**
     * Should the alert fly out from the side of the screen instead of being contained within the main PageContainer.
     *
     * @default false
     */
    this.flyout = false;
    /**
     * Allows the automatic page scrolling to the top when the alert is not fully visible (not for flyout alerts, only global alerts).
     *
     * @default true
     */
    this.autoScroll = true;
    /**
     * Alert route. Mainly affects text style
     */
    this.route = null;
    /**
     * For type checking.
     *
     * @default true
     */
    this.isAlertModel = true;
    this.message = message;
    this.alertType = alertType;
    this.autoClose = autoClose;
    this.flyout = flyout;
    this.autoCloseDelay = autoCloseDelay !== null && autoCloseDelay !== void 0 ? autoCloseDelay : null;
    this.route = route;
  }
  static isEqual(x, y) {
    return Utility.getHashCode(x) === Utility.getHashCode(y);
  }
}

class BasePageParameters {}

class DescriptionModel {
  constructor() {
    this.readonly = false;
    this.className = null;
    this.description = "";
    this.align = Align.Bottom;
    this.justify = Justify.Left;
    /**
     * Max length for the description text area.
     */
    this.maxLength = null;
    this.isDescriptionModel = true;
  }
}

var DocumentPreviewSize;
(function (DocumentPreviewSize) {
  DocumentPreviewSize[DocumentPreviewSize["Large"] = 0] = "Large";
  DocumentPreviewSize[DocumentPreviewSize["Medium"] = 1] = "Medium";
})(DocumentPreviewSize || (DocumentPreviewSize = {}));
class DocumentPreviewModel {
  constructor() {
    this.title = null;
    this.subtitle = null;
    this.size = DocumentPreviewSize.Large;
    this.document = new FileModel();
  }
}

class PageRoute {
  constructor(name, index = null, id = null, parameters = null) {
    this.isPageRoute = true;
    this.name = name;
    this.index = index;
    this.id = id;
    this.parameters = parameters;
    this.isPageRoute = true;
  }
  /**
   * Convert a {@link PageRoute} to a relative path.
   *
   * @param route Route to convert to a path.
   */
  static toRelativePath(route) {
    let path = "/";
    const localizer = ServiceProvider.findLocalizer();
    const localizedRouteKey = `PageRoutes.${route.name}`;
    const pageName = (localizer === null || localizer === void 0 ? void 0 : localizer.contains(localizedRouteKey, localizer === null || localizer === void 0 ? void 0 : localizer.language)) ? localizer.get(localizedRouteKey) : route.name;
    // "/pageName"
    path += pageName;
    // Id can only be set in non-root pages, as otherwise it would be considered as the page name.
    if (pageName && route.id) {
      // "/pageName/id"
      path += `/${route.id}`;
    }
    if (route.parameters) {
      let query = "";
      //Querystring.stringify had a problem with parameters object so had to do it this way
      for (const [key, value] of Object.entries(route.parameters)) {
        const improper = !key || typeof value === "function" || typeof value === "symbol";
        if (improper) {
          continue;
        }
        if (query) {
          query += "&";
        }
        const properValue = typeof value === "object" ? JSON.stringify(value) : value;
        query += `${key}=${properValue}`;
      }
      if (query) {
        // "/pageName{/id}?query=query&query=query"
        path += `?${query}`;
      }
    }
    return path;
  }
  static normalize(route) {
    if (!route) {
      return;
    }
    //Ensure that the default values are null.
    if (!route.id) {
      route.id = null;
    }
    if (!route.parameters) {
      route.parameters = null;
    }
  }
  static isEqual(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (x.name !== y.name) {
      return false;
    }
    if (x.index !== y.index) {
      return false;
    }
    if (x.id !== y.id) {
      return false;
    }
    if (x.parameters == null && y.parameters == null) {
      return true;
    }
    if (Utility.getHashCode(x.parameters) != Utility.getHashCode(y.parameters)) {
      return false;
    }
    return true;
  }
}

class TokenData {
  constructor() {
    this.TypeName = "";
  }
}

class ServerError {
  constructor(requestId) {
    this.requestId = requestId;
  }
}

class ArrayScope {
  constructor() {
    this.firstIndex = 0;
    this.lastIndex = 0;
    this.isArrayScope = true;
  }
}

class ETagRequest {
  constructor() {
    this.eTag = 0;
    this.isETagRequest = true;
  }
}

class ETagResponse {
  constructor() {
    this.eTag = 0;
    this.isETagResponse = true;
  }
}

class LdData {
  constructor() {
    this.json = null;
    this.description = null;
    this.keywords = null;
    this.canonical = null;
    this.defaultLanguage = null;
    this.title = null;
    this.googleVerificationKey = null;
    this.isLdData = true;
  }
}

class LocalizationStringItem {
  constructor() {
    this.language = "";
    this.value = "";
    this.robot = false;
    this.isLocalizationStringItem = true;
  }
}

class LocalizationString {
  constructor() {
    this.items = [];
    this.isLocalizationString = true;
  }
  static create(value, language) {
    const localizer = ServiceProvider.getLocalizer();
    const item = new LocalizationStringItem();
    item.language = language !== null && language !== void 0 ? language : localizer.defaultLanguage;
    item.value = value;
    const localizedString = new LocalizationString();
    localizedString.items = [item];
    return localizedString;
  }
  static value(localizedString) {
    var _a;
    let value = "";
    if (localizedString != null && localizedString.items && localizedString.items.length > 0) {
      const localizer = ServiceProvider.getLocalizer();
      const language = localizer.language;
      const item = (_a = localizedString.items.firstOrDefault(item => item.language == language)) !== null && _a !== void 0 ? _a : localizedString.items.first();
      value = item.value;
    }
    return value;
  }
  static normalize(localizedString, languages, defaultLanguage) {
    const localizer = ServiceProvider.getLocalizer();
    languages !== null && languages !== void 0 ? languages : languages = localizer.supportedLanguages.select(item => item.code);
    defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : defaultLanguage = localizer.defaultLanguage;
    const length = languages.length;
    for (let i = 0; i < length; i++) {
      const language = languages[i];
      if (!localizedString.items.any(item => item.language == language)) {
        const item = new LocalizationStringItem();
        item.language = language;
        localizedString.items.push(item);
      }
    }
    localizedString.items.sortBy(item => item.language != defaultLanguage, item => item.language);
  }
  static valid(value, required) {
    return value.items != null && value.items.length > 0 && (!required || value.items.all(item => !!item.value));
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class ReactUtility {
  //#region Private
  static split(regex, tag, text, containerIndex) {
    const items = (text || "").split(regex);
    const tags = items.map((item, index) => index % 2 != 0 ? [React.createElement(tag, {
      key: `_${containerIndex}${tag}${index}`
    }, item)] : [item]);
    return tags && Array.isArray(tags) && typeof tags.flat === "function" ? tags.flat().filter(tag => !!tag) : [];
  }
  static containerToTags(text, containerIndex) {
    let tags = this.containerToMarks(text, containerIndex);
    tags = this.invoke(tags, item => this.containerToSmalls(item, containerIndex));
    tags = this.invoke(tags, item => this.containerToItalics(item, containerIndex));
    tags = this.invoke(tags, item => this.containerToBolds(item, containerIndex));
    tags = this.invoke(tags, item => this.containerToUnderscores(item, containerIndex));
    return tags;
  }
  static containerToMarks(text, containerIndex) {
    return this.split(AthenaeumConstants.markTagRegex, "mark", text, containerIndex);
  }
  static containerToSmalls(text, containerIndex) {
    return this.split(AthenaeumConstants.smallTagRegex, "small", text, containerIndex);
  }
  static containerToBolds(text, containerIndex) {
    return this.split(AthenaeumConstants.boldTagRegex, "b", text, containerIndex);
  }
  static containerToItalics(text, containerIndex) {
    return this.split(AthenaeumConstants.italicTagRegex, "i", text, containerIndex);
  }
  static containerToUnderscores(text, containerIndex) {
    return this.split(AthenaeumConstants.underscoreTagRegex, "u", text, containerIndex);
  }
  static invoke(tags, action) {
    const items = tags.map(item => {
      return typeof item === "string" ? action(item) : Array.isArray(item) ? this.invoke(item, action) : item;
    });
    return items && Array.isArray(items) && typeof items.flat === "function" ? items.flat() : [];
  }
  //#endregion
  static toMarks(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToMarks(text, 0);
  }
  static toSmalls(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToSmalls(text, 0);
  }
  static toBolds(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToBolds(text, 0);
  }
  static toItalics(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToItalics(text, 0);
  }
  static toUnderscores(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToUnderscores(text, 0);
  }
  static toSingleLine(text) {
    // check
    if (!text) {
      return "";
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return "";
    }
    return text.replace(AthenaeumConstants.newLineRegex, " ");
  }
  static toMultiLines(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    const lines = text.split(AthenaeumConstants.newLineRegex);
    const items = lines.map((line, index) => index < lines.length - 1 ? [...this.containerToTags(line, index), React.createElement("br", {
      key: "br" + index
    })] : [...this.containerToTags(line, index)]);
    return items && Array.isArray(items) && typeof items.flat === "function" ? items.flat() : [];
  }
  static toTags(text, toSingleLine = true) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    if (toSingleLine) {
      text = this.toSingleLine(text);
    }
    return this.containerToTags(text, 0);
  }
}

var LayoutBreak;
(function (LayoutBreak) {
  /**
   * $break-xxs
   */
  LayoutBreak[LayoutBreak["Xxs"] = 310] = "Xxs";
  /**
   * $break-xs
   */
  LayoutBreak[LayoutBreak["Xs"] = 480] = "Xs";
  /**
   * $break-sm
   */
  LayoutBreak[LayoutBreak["Sm"] = 640] = "Sm";
  /**
   * $break-md
   */
  LayoutBreak[LayoutBreak["Md"] = 768] = "Md";
  /**
   * $break-lg
   */
  LayoutBreak[LayoutBreak["Lg"] = 1024] = "Lg";
  /**
   * $break-xlg
   */
  LayoutBreak[LayoutBreak["Xlg"] = 1280] = "Xlg";
  /**
   * $break-xxlg
   */
  LayoutBreak[LayoutBreak["Xxlg"] = 1460] = "Xxlg";
})(LayoutBreak || (LayoutBreak = {}));
var LayoutType;
(function (LayoutType) {
  /**
   * [0 - 310px]
   */
  LayoutType[LayoutType["ExtraExtraSmall"] = 0] = "ExtraExtraSmall";
  /**
   * [310px - 480px]
   */
  LayoutType[LayoutType["ExtraSmall"] = 1] = "ExtraSmall";
  /**
   * [480px - 640px]
   */
  LayoutType[LayoutType["Small"] = 2] = "Small";
  /**
   * [640px - 768px]
   */
  LayoutType[LayoutType["Medium"] = 3] = "Medium";
  /**
   * [768px - 1024px]
   */
  LayoutType[LayoutType["Large"] = 4] = "Large";
  /**
   * [1024px - 1280px]
   */
  LayoutType[LayoutType["ExtraLarge"] = 5] = "ExtraLarge";
  /**
   * [1280px - 1460px]
   */
  LayoutType[LayoutType["ExtraExtraLarge"] = 6] = "ExtraExtraLarge";
  /**
   * [>1460px]
   */
  LayoutType[LayoutType["Enormous"] = 7] = "Enormous";
})(LayoutType || (LayoutType = {}));
/**
 * {@link BaseComponent} helper.
 * Provides helper functions for component initialization.
 */
class ch {
  static onOnSetLanguageAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield ApiProvider.postAsync("/api/Application/OnSetLanguage", language, null);
      } catch (e) {
        //no additional action needed, not critical
        console.error(e);
      }
    });
  }
  static onInitializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.forEachAsync(this._initializeCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
        return yield callback();
      }));
    });
  }
  static onAuthorizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.forEachAsync(this._authorizeCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
        return yield callback();
      }));
    });
  }
  /**
   * If the input {@link IBaseComponent} is an {@link ILayoutPage}, set it as the current {@link ILayoutPage},
   * or if it is an {@link IBasePage}, set it as the current {@link IBasePage}.
   * Otherwise do nothing.
   *
   * @param component {@link IBaseComponent} to set as the current {@link ILayoutPage} or {@link IBasePage}.
   */
  static register(component) {
    const layout = component;
    if (layout && layout.isLayout && layout.isLayout()) {
      this._layout = layout;
      return;
    }
    const page = component;
    if (page && page.isPage && page.isPage()) {
      this._page = page;
      return;
    }
  }
  /**
   * Sets context
   * @param context {@link ApplicationContext} to set as the current context.
   */
  static setContextAsync(context) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._context !== context) {
        const authorize = !!this._context && this._context.username !== context.username;
        //set context
        this._context = context;
        if (!this._initialized) {
          this._initialized = true;
          yield this.onInitializeAsync();
        }
        if (authorize) {
          yield this.onAuthorizeAsync();
        }
        if (this._layout != null) {
          const localizer = ServiceProvider.findLocalizer();
          const newLanguage = context != null && localizer != null && localizer.setLanguage(context.language);
          const newCountry = context != null && (this._context == null || this._context.country != context.country);
          if (newCountry || newLanguage) {
            //reload layout
            yield this._layout.reRenderAsync();
          } else {
            //reload top nav
            yield this._layout.reloadTopNavAsync();
            //reload left nav
            yield this._layout.reloadLeftNavAsync();
          }
        }
      }
    });
  }
  /**
   * @see ILayoutPage.reloadTopNavAsync
   */
  static reloadTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.reloadTopNavAsync();
      }
    });
  }
  /**
   * @see ILayoutPage.reRenderTopNavAsync
   */
  static reRenderTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.reRenderTopNavAsync();
      }
    });
  }
  /**
   * @see ILayoutPage.reloadLeftNavAsync
   */
  static reloadLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.reloadLeftNavAsync();
      }
    });
  }
  /**
   * @see ILayoutPage.reRenderTopNavAsync
   */
  static reRenderLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.reRenderLeftNavAsync();
      }
    });
  }
  /**
   * Calls {@link reloadTopNavAsync} without awaiting.
   */
  static reloadTopNav() {
    // noinspection JSIgnoredPromiseFromCall
    this.reloadTopNavAsync();
  }
  /**
   * Calls {@link reloadTopNavAsync} without awaiting.
   */
  static reRenderTopNav() {
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderTopNavAsync();
  }
  /**
   * Calls {@link reloadLeftNavAsync} without awaiting.
   */
  static reloadLeftNav() {
    // noinspection JSIgnoredPromiseFromCall
    this.reloadLeftNavAsync();
  }
  /**
   * Calls {@link reloadTopNavAsync} without awaiting.
   */
  static reRenderLeftNav() {
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderLeftNavAsync();
  }
  /**
   * @see ILayoutPage.alertAsync
   */
  static alertAsync(alert) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.alertAsync(alert);
      }
    });
  }
  /**
   * @see ILayoutPage.alert
   */
  static get alert() {
    return this._layout != null ? this._layout.alert : null;
  }
  /**
   * @see ILayoutPage.pageUrl
   */
  static get pageUrl() {
    return this._layout != null ? this._layout.pageUrl : window.location.href;
  }
  /**
   * Returns the application URL (the root URL) from the application context,
   * or the page 'origin' if the context or application URL is not specified
   */
  static get applicationUrl() {
    const context = this.findContext();
    return (context === null || context === void 0 ? void 0 : context.applicationUrl) || window.location.origin;
  }
  /**
   * Display an error alert in the current {@link ILayoutPage}.
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one.
   */
  static alertErrorAsync(message, autoClose = false, flyout = false, autoCloseDelay, route = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const alert = new AlertModel(message, AlertType.Danger, autoClose, flyout, autoCloseDelay, route);
      yield this.alertAsync(alert);
    });
  }
  /**
   * Display a flyout error alert in the current {@link ILayoutPage}.
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one.
   */
  static flyoutErrorAsync(message, autoCloseDelay) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.alertErrorAsync(message, true, true, autoCloseDelay);
    });
  }
  /**
   * Display an alert in the current {@link ILayoutPage}.
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one.
   */
  static alertMessageAsync(message, autoClose = false, flyout = false, autoCloseDelay, route = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const alert = new AlertModel(message, AlertType.Success, autoClose, flyout, autoCloseDelay, route);
      yield this.alertAsync(alert);
    });
  }
  /**
   * Display a flyout alert in the current {@link ILayoutPage}.
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one.
   */
  static flyoutMessageAsync(message, autoCloseDelay) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.alertMessageAsync(message, true, true, autoCloseDelay);
    });
  }
  /**
   * Display a warning alert in the current {@link ILayoutPage}.
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one.
   */
  static alertWarningAsync(message, autoClose = false, flyout = false, autoCloseDelay, route = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const alert = new AlertModel(message, AlertType.Warning, autoClose, flyout, autoCloseDelay, route);
      yield this.alertAsync(alert);
    });
  }
  /**
   * Display a flyout warning alert in the current {@link ILayoutPage}.
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one.
   */
  static flyoutWarningAsync(message, autoCloseDelay) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.alertWarningAsync(message, true, true, autoCloseDelay);
    });
  }
  /**
   * Hide the alert being displayed in the current {@link ILayoutPage}.
   */
  static hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.hideAlertAsync();
      }
    });
  }
  static confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._page != null && (yield this._page.confirmAsync(title));
    });
  }
  static messageBoxAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._page != null ? yield this._page.messageBoxAsync(titleOrModel, caption, buttons, icon) : DialogResult.None;
    });
  }
  static documentPreviewAsync(endpoint, request, title = null, size = DocumentPreviewSize.Large) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        const model = new DocumentPreviewModel();
        model.document = sender => __awaiter(this, void 0, void 0, function* () {
          return yield sender.postAsync(endpoint, request);
        });
        model.title = title;
        model.size = size;
        yield this._page.documentPreviewAsync(model);
      }
    });
  }
  static preloadedDocumentPreviewAsync(document, title = null, size = DocumentPreviewSize.Large) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        const model = new DocumentPreviewModel();
        model.document = document;
        model.title = title;
        model.size = size;
        yield this._page.documentPreviewAsync(model);
      }
    });
  }
  static descriptionAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        yield this._page.descriptionAsync(containerId, model);
      }
    });
  }
  static reinitializeContextAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._context = null;
      if (this._layout != null) {
        yield this._layout.reloadAsync();
      }
    });
  }
  static registerInitializeCallback(callback) {
    this._initializeCallbacks.push(callback);
  }
  static registerAuthorizeCallback(callback) {
    this._authorizeCallbacks.push(callback);
  }
  static registerRedirectCallback(callback) {
    PageRouteProvider.registerRedirectCallback(callback);
  }
  static registerRouteResolver(routeResolver) {
    PageRouteProvider.registerRouteResolver(routeResolver);
  }
  /**
   * @returns Current {@link ApplicationContext}.
   *
   * @throws Current {@link ApplicationContext} is not defined.
   */
  static getContext() {
    if (this._context == null) throw Error(`Component helper. Context is not defined.`);
    return this._context;
  }
  /**
   * @returns Current {@link ApplicationContext}, or null if not defined.
   */
  static findContext() {
    return this._context;
  }
  static get versionId() {
    const context = this.findContext();
    return (context === null || context === void 0 ? void 0 : context.versionId) || null;
  }
  static get timezoneOffset() {
    const context = this.findContext();
    return (context === null || context === void 0 ? void 0 : context.timezoneOffset) || null;
  }
  static get country() {
    const context = this.getContext();
    return context.country;
  }
  static get language() {
    const context = this.getContext();
    return context.language;
  }
  static get isInitialPage() {
    return PageRouteProvider.isInitialPage;
  }
  static get isCrawler() {
    const context = this.findContext();
    return (context === null || context === void 0 ? void 0 : context.isCrawler) === true;
  }
  static getUser() {
    const user = this.findUser();
    if (user) {
      return user;
    }
    throw Error(AthenaeumConstants.userNotDefinedError);
  }
  static findUsername() {
    const user = this.findUser();
    return user ? user.username : null;
  }
  static findUser() {
    const context = this.findContext();
    const userContext = context;
    if (userContext && userContext.isUserContext && userContext.user && userContext.user.username) {
      return userContext.user;
    }
    return null;
  }
  static getUserId() {
    return this.getUser().id;
  }
  static getSessionId() {
    if (this._context) {
      const userContext = this._context;
      if (userContext.isUserContext && userContext.username) {
        return userContext.username.getHashCode().toString();
      }
    }
    return "";
  }
  static getApplicationSessionId() {
    return this._context ? this._context.id : "";
  }
  static setLanguageAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      const localizer = ServiceProvider.findLocalizer();
      if (localizer && localizer.setLanguage(language)) {
        // update context
        if (this._context != null) {
          this._context.language = language;
        }
        // do not await, just notification event
        // noinspection ES6MissingAwait
        ch.onOnSetLanguageAsync(language);
        // re-render layout
        const layout = this.getLayout();
        yield layout.reRenderAsync();
      }
    });
  }
  /**
   * Reload the current page.
   */
  static refresh() {
    window.location.reload();
  }
  /**
   * Post auth token to the specified Url: http(s)://application_path/?token=TOKEN
   */
  static postToken(tokenUrl, stopPropagation = false) {
    const key = "?token=";
    const index = tokenUrl.indexOf(key);
    if (index == -1) throw Error(`Component helper. PostToken. Token url cannot be parsed, token doesn't exists.`);
    const url = tokenUrl.substring(0, index - 1);
    const token = tokenUrl.substring(index + key.length);
    const form = document.createElement("form");
    form.action = url;
    form.method = "POST";
    form.target = "_self";
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "token";
    input.id = "token";
    input.value = token;
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    if (stopPropagation) {
      PageRouteProvider.stopPropagation();
    }
  }
  static reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.findPage();
      if (page) {
        yield page.reRenderAsync();
      }
    });
  }
  /**
   * Gets Xsrf Token
   * @returns XSRF token if it is specified
   */
  static getXsrfToken() {
    return this._context != null ? this._context.xsrfToken : null;
  }
  /**
   * @returns Current {@link ILayoutPage}.
   *
   * @throws {Error} Current {@link ILayoutPage} is not specified.
   */
  static getLayout() {
    if (this._layout == null) throw Error(`Component helper. Layout is not defined.`);
    return this._layout;
  }
  /**
   * @returns Current {@link IBasePage}.
   *
   * @throws {Error} Current {@link IBasePage} is not defined.
   */
  static getPage() {
    if (this._page == null) throw Error(`Component helper. Page is not defined.`);
    return this._page;
  }
  /**
   * @returns Current {@link IBasePage}, or null if not defined.
   */
  static findPage() {
    return this._page;
  }
  static findPageId() {
    return this._page != null ? this._page.id : "";
  }
  static findRouteName() {
    return this._page != null ? this._page.routeName : "";
  }
  static findPageRoute() {
    return this._page != null ? this._page.route : null;
  }
  static swipeLeftAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.swipeLeftAsync();
      }
    });
  }
  static swipeRightAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.swipeRightAsync();
      }
    });
  }
  /**
   * True for LOCAL and DEV (TEST and STAGING) environments
   * False for PRODUCTION environment
   */
  static get isDevelopment() {
    return this._context != null && this._context.isDevelopment;
  }
  /**
   * True for LOCAL environment only
   * False DEV (TEST and STAGING) and PRODUCTION environments
   */
  static get isDevelopmentVS() {
    return this._context != null && this._context.isDevelopmentVS;
  }
  static get isAuthenticated() {
    const user = this.findUser();
    return !!user;
  }
  /**
   * Is the current application mobile (located under "/mobile" domain) or PWA application ("display-mode: standalone" or referrer has "android-app://"))
   */
  static get mobileApp() {
    return this._context != null && (this._context.mobileApp || this._context.pwaApp);
  }
  /**
   * Is the current window width below {@link AthenaeumConstants.desktopMinWidth}.
   */
  static get mobile() {
    return !this.desktop;
  }
  /**
   * Is the current window width above {@link AthenaeumConstants.desktopMinWidth}.
   */
  static get desktop() {
    return window.innerWidth >= AthenaeumConstants.desktopMinWidth;
  }
  static getType(size) {
    if (size <= LayoutBreak.Xxs) {
      return LayoutType.ExtraExtraSmall;
    }
    if (size <= LayoutBreak.Xs) {
      return LayoutType.ExtraSmall;
    }
    if (size <= LayoutBreak.Sm) {
      return LayoutType.Small;
    }
    if (size <= LayoutBreak.Md) {
      return LayoutType.Medium;
    }
    if (size <= LayoutBreak.Lg) {
      return LayoutType.Large;
    }
    if (size <= LayoutBreak.Xlg) {
      return LayoutType.ExtraLarge;
    }
    if (size <= LayoutBreak.Xxlg) {
      return LayoutType.ExtraExtraLarge;
    }
    return LayoutType.Enormous;
  }
  static get verticalLayoutType() {
    return this.getType(window.innerHeight);
  }
  static get horizontalLayoutType() {
    return this.getType(window.innerWidth);
  }
  static get landscape() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const orientationType = ((_b = (_a = window.screen) === null || _a === void 0 ? void 0 : _a.orientation) === null || _b === void 0 ? void 0 : _b.type) || ((_c = screen === null || screen === void 0 ? void 0 : screen.orientation) === null || _c === void 0 ? void 0 : _c.type) || ((_e = (_d = window.screen) === null || _d === void 0 ? void 0 : _d.lockOrientation) === null || _e === void 0 ? void 0 : _e.type) || ((_f = screen.lockOrientation) === null || _f === void 0 ? void 0 : _f.type) || ((_h = (_g = window.screen) === null || _g === void 0 ? void 0 : _g.mozOrientation) === null || _h === void 0 ? void 0 : _h.type) || ((_j = screen.mozOrientation) === null || _j === void 0 ? void 0 : _j.type) || ((_l = (_k = window.screen) === null || _k === void 0 ? void 0 : _k.msOrientation) === null || _l === void 0 ? void 0 : _l.type) || ((_m = screen.msOrientation) === null || _m === void 0 ? void 0 : _m.type);
    const windowOrientationType = window.orientation;
    return orientationType != null && orientationType.includes("landscape") || window.matchMedia("(orientation: landscape)").matches || windowOrientationType == 90 || windowOrientationType == -90;
  }
  static portrait() {
    return !this.landscape;
  }
  static get version() {
    return this._context != null ? this._context.version : "";
  }
  static download(file) {
    if (this._layout != null) {
      this._layout.download(file);
    }
  }
  static print(file, target, features) {
    const objectUrl = Utility.toObjectUrl(file);
    window.open(objectUrl, target, features);
  }
  static takePictureAsync(camera = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        return this._layout.takePictureAsync(camera);
      }
      return null;
    });
  }
  static callTo(phone) {
    if (this._layout != null) {
      return this._layout.callTo(phone);
    }
  }
  static smsTo(phone, message) {
    if (this._layout != null) {
      return this._layout.smsTo(phone, message);
    }
  }
  static mailTo(email) {
    if (this._layout != null) {
      return this._layout.mailTo(email);
    }
  }
  /**
   * Gets unique id
   * @returns id - number
   */
  static getId() {
    return Utility.getId();
  }
  /**
   * Gets component id
   * @returns id - number
   */
  static getComponentId() {
    return Utility.getComponentId();
  }
  static get offline() {
    return ApiProvider.offline;
  }
  static get online() {
    return !this.offline;
  }
  static get debug() {
    return this._debug;
  }
  static set debug(value) {
    this._debug = value;
  }
}
ch._initializeCallbacks = [];
ch._authorizeCallbacks = [];
ch._context = null;
ch._layout = null;
ch._page = null;
ch._initialized = false;
ch._debug = false;

/**
 * Page Cache provider
 */
var PageCacheTtl;
(function (PageCacheTtl) {
  PageCacheTtl[PageCacheTtl["_1m"] = 60000] = "_1m";
  PageCacheTtl[PageCacheTtl["_5m"] = 300000] = "_5m";
  PageCacheTtl[PageCacheTtl["_30m"] = 1800000] = "_30m";
  PageCacheTtl[PageCacheTtl["_1h"] = 3600000] = "_1h";
  PageCacheTtl[PageCacheTtl["_24h"] = 86400000] = "_24h";
})(PageCacheTtl || (PageCacheTtl = {}));
class PageCacheProviderContainer {
  constructor() {
    this.lock = new Mutex();
    this.data = new Dictionary();
  }
}
class PageCacheProvider {
  static clearKeyAsync(container, key) {
    return __awaiter(this, void 0, void 0, function* () {
      yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        container.data.remove(key);
      }));
    });
  }
  static escapeRegExp(pattern) {
    return pattern.replace(/[.*+?^${}()|[]\\\/]/g, "\\$&");
  }
  static wildcardToRegex(pattern) {
    pattern = this.escapeRegExp(pattern);
    pattern = pattern.replace(/[*]/g, ".*").replace(/[?]/g, "?");
    return new RegExp(`^${pattern}$`, "i");
  }
  static getKeyPrefix(hasTtl) {
    return hasTtl ? `${ch.findUsername()}:` : `${ch.findUsername()}:${ch.findRouteName()}:`;
  }
  static getKey(key, hasTtl) {
    const prefix = this.getKeyPrefix(hasTtl);
    return prefix + key;
  }
  static clearKeys(data, prefix, regex) {
    const keys = data.keys();
    const length = keys.length;
    if (length > 0) {
      const prefixLength = prefix.length;
      for (let i = 0; i < length; i++) {
        const key = keys[i];
        if (key.startsWith(prefix)) {
          const keyWithoutPrefix = key.substring(prefixLength);
          if (regex.test(keyWithoutPrefix)) {
            data.remove(key);
          }
        }
      }
    }
  }
  static clear(key = null) {
    if (key) {
      if (key.includes("*") || key.includes("?")) {
        const ttlPrefix = this.getKeyPrefix(true);
        const pagePrefix = this.getKeyPrefix(false);
        const regex = this.wildcardToRegex(key);
        this.clearKeys(this._dataTtl.data, ttlPrefix, regex);
        this.clearKeys(this._data.data, pagePrefix, regex);
      } else {
        const ttlKey = this.getKey(key, true);
        const pageKey = this.getKey(key, false);
        this._dataTtl.data.remove(ttlKey);
        this._data.data.remove(pageKey);
      }
    } else {
      this._data.data.clear();
    }
  }
  static getAsync(key, action, ttl = 0) {
    return __awaiter(this, void 0, void 0, function* () {
      const hasTtl = ttl > 0;
      const container = hasTtl ? this._dataTtl : this._data;
      key = this.getKey(key, hasTtl);
      let data = undefined;
      yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        data = container.data.getValue(key);
        if (data == null) {
          data = yield action();
          if (data != null) {
            container.data.setValue(key, data);
          }
        }
      }));
      if (hasTtl) {
        setTimeout(() => this.clearKeyAsync(container, key), ttl);
      }
      return data;
    });
  }
}
PageCacheProvider._data = new PageCacheProviderContainer();
PageCacheProvider._dataTtl = new PageCacheProviderContainer();

class BasePageDefinitions {
  register(pageName) {
    return __awaiter(this, void 0, void 0, function* () {
      const fullPageName = pageName;
      if (BasePageDefinitions._pages.containsKey(fullPageName)) {
        return BasePageDefinitions._pages.getValue(fullPageName);
      }
      const pageNameItems = pageName.split("/");
      let pageContainer = "";
      if (pageNameItems.length > 1) {
        pageContainer = pageNameItems.slice(0, pageNameItems.length - 1).join("/") + "/";
        pageName = pageNameItems[pageNameItems.length - 1];
      }
      //const module: any = await require(`../pages/${pageContainer}${pageName}/${pageName}`);
      const module = yield this.require(pageContainer, pageName);
      const constructor = module.default;
      BasePageDefinitions._pages.setValue(fullPageName, constructor);
      BasePageDefinitions._modules.setValue(fullPageName, module);
      return constructor;
    });
  }
  constructor() {
    ServiceProvider.addSingleton(this);
  }
  static initialize() {}
  getType() {
    return "IPageDefinitions";
  }
  static getRoutes() {
    var _a;
    return (_a = this.pageRoutesDictionary) !== null && _a !== void 0 ? _a : new Map();
  }
  createPageAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageName = route.name;
      try {
        const pageConstructor = yield this.register(pageName);
        const props = {
          parameters: route.parameters,
          routeIndex: route.index,
          routeId: route.id,
          routeName: pageName
        };
        return new pageConstructor(props);
      } catch (e) {
        throw Error(`Unknown route "${pageName}", module or page component cannot be found. ${e}`);
      }
    });
  }
  render(page, ref) {
    const pageName = page.routeName;
    const routeIndex = page.routeIndex;
    const routeId = page.routeId;
    const parameters = page.parameters;
    const parametersHashCode = Utility.getHashCode(parameters);
    const key = `${pageName}:${routeIndex}:${routeId}:${parametersHashCode}`;
    const props = {
      ref: ref,
      key: key,
      parameters: parameters,
      routeIndex: routeIndex,
      routeId: routeId,
      routeName: pageName
    };
    const module = BasePageDefinitions._modules.getValue(pageName);
    // noinspection UnnecessaryLocalVariableJS
    const element = React.createElement(module.default, props);
    return element;
  }
}
BasePageDefinitions._pages = new Dictionary();
BasePageDefinitions._modules = new Dictionary();
BasePageDefinitions.loginRouteName = "Login";
BasePageDefinitions.loginRoute = new PageRoute(BasePageDefinitions.loginRouteName);
BasePageDefinitions.logoutRouteName = "Logout";
BasePageDefinitions.logoutRoute = new PageRoute(BasePageDefinitions.logoutRouteName);
BasePageDefinitions.contactSupportRouteName = "ContactSupport";
/**
 * The route for contact support page. Application automatically redirects to this route in case of the
 * following urls: https://application_url/#contact or https://application_url/#support
 */
BasePageDefinitions.contactSupportRoute = new PageRoute(BasePageDefinitions.contactSupportRouteName);
BasePageDefinitions.privacyPolicyRouteName = "PrivacyPolicy";
/**
 * The route for privacy policy page. Application automatically redirects to this route in case of the
 * following urls: https://application_url/#privacypolicy or https://application_url/#privacy
 */
BasePageDefinitions.privacyPolicyRoute = new PageRoute(BasePageDefinitions.privacyPolicyRouteName);
BasePageDefinitions.authorsRouteName = "Authors";
/**
 * The route for authors page. Application automatically redirects to this route in case of the
 * following urls: https://application_url/#authors or https://application_url/authors
 */
BasePageDefinitions.authorsRoute = new PageRoute(BasePageDefinitions.authorsRouteName);
BasePageDefinitions.dummyRouteName = "Dummy";
BasePageDefinitions.dummyRoute = new PageRoute(BasePageDefinitions.dummyRouteName);
BasePageDefinitions.offlineRouteName = "Offline";
BasePageDefinitions.offlineRoute = new PageRoute(BasePageDefinitions.offlineRouteName);
BasePageDefinitions.errorRouteName = "Error";
BasePageDefinitions.errorRoute = new PageRoute(BasePageDefinitions.errorRouteName);

class PageRouteProvider {
  static initialize() {
    if (!this._initialized) {
      this._initialized = true;
      this._isInitialPage = true;
      window.addEventListener("popstate", e => this.onPopStateAsync(e));
    } else {
      this._isInitialPage = false;
    }
  }
  static onPopStateAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const route = e.state || BasePageDefinitions.dummyRoute;
      yield this.invokeRedirectAsync(route, null, true);
    });
  }
  static logoutAsync(layout) {
    return __awaiter(this, void 0, void 0, function* () {
      yield layout.postAsync("/api/Application/Logout", null);
      PageRouteProvider.stopPropagation();
    });
  }
  static onRedirectAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        if (!this.sendParametersOnRedirect && !ch.getLayout().useRouting) {
          route.parameters = null;
        }
        yield ApiProvider.postAsync("/api/Application/OnRedirect", route);
      } catch (e) {
        //no additional action needed, not critical
      }
    });
  }
  static onRedirectCallbackAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield Utility.forEachAsync(this._redirectCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
          return yield callback(route);
        }));
      } catch (e) {
        //no additional action needed, not critical
      }
    });
  }
  static onRedirect(route) {
    // Send message to BE for logging:
    // do not await, just notification event
    // noinspection JSIgnoredPromiseFromCall
    setTimeout(() => this.onRedirectAsync(route), 0);
    // Invoke "Redirect" callback:
    // do not await, just notification event
    // noinspection JSIgnoredPromiseFromCall
    this.onRedirectCallbackAsync(route);
  }
  static onJsErrorAsync(serverError) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        const ignore = !!serverError.debugDetails && serverError.debugDetails.includes(AthenaeumConstants.userNotDefinedError);
        if (!ignore) {
          yield ApiProvider.postAsync("/api/Application/OnJsError", serverError);
        }
      } catch (e) {
        //no additional action needed, not critical
      }
    });
  }
  static invokeRedirectAsync(route, id = null, innerRedirect, replace = false, stopPropagation = false) {
    return __awaiter(this, void 0, void 0, function* () {
      this.initialize();
      const context = ch.getContext();
      const currentPage = ch.findPage();
      const layout = ch.getLayout();
      if (id) {
        route = Object.assign({}, route);
        route.id = id;
      }
      //PageRoute in history might be newer than in context. (params might change in page)
      //It will be updated to session context in onRedirect. 
      const oldRoute = layout.useRouting ? window.history.state : context.currentPage;
      if (layout.useRouting) {
        PageRoute.normalize(oldRoute);
        PageRoute.normalize(route);
      }
      const routesAreEqual = PageRoute.isEqual(oldRoute, route);
      const newPage = currentPage == null || currentPage.routeName !== route.name || !routesAreEqual;
      if (newPage) {
        if (route.name === BasePageDefinitions.dummyRouteName) {
          return currentPage;
        }
        if (currentPage != null) {
          const canRedirect = yield currentPage.beforeRedirectAsync(route, innerRedirect);
          if (!canRedirect) {
            const currentRoute = currentPage.route;
            window.history.pushState(currentRoute, currentRoute.name);
            yield currentPage.reRenderAsync();
            return currentPage;
          }
        }
        if (route.name === BasePageDefinitions.logoutRouteName) {
          yield this.logoutAsync(layout);
          return currentPage;
        }
        let newAlert = null;
        if (currentPage != null) {
          const currentAlert = currentPage.alert;
          // New alert was triggered in method "beforeRedirectAsync";
          if (!AlertModel.isEqual(currentAlert, currentPage.alert)) {
            newAlert = currentPage.alert;
          }
          // Hide current alert
          yield currentPage.hideAlertAsync();
        }
        const page = yield this.createPageAsync(route);
        context.currentPage = route;
        yield layout.setPageAsync(page);
        // Show new alert
        if (newAlert != null) {
          yield page.alertAsync(newAlert);
        }
        // if (current != null) {
        //     await current!.hideAlertAsync();
        // }
        if (!innerRedirect) {
          if (!layout.useRouting || !routesAreEqual) {
            if (replace) {
              window.history.replaceState(route, route.name);
            } else {
              window.history.pushState(route, route.name);
            }
          }
        }
        document.title = page.getTitle();
        if (!this._isInitialPage && route.name !== BasePageDefinitions.errorRouteName) {
          // clear cache
          PageCacheProvider.clear();
          this.onRedirect(route);
        }
        if (stopPropagation) {
          this.stopPropagation();
        }
        return page;
      }
      return currentPage;
    });
  }
  static redirectAsync(route, replace = false, stopPropagation = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.invokeRedirectAsync(route, null, false, replace, stopPropagation);
    });
  }
  static createPageAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageDefinitions = ServiceProvider.getRequiredService("IPageDefinitions");
      return yield pageDefinitions.createPageAsync(route);
    });
  }
  static changeUrlWithoutReload(newPath) {
    return __awaiter(this, void 0, void 0, function* () {
      if (newPath == null) {
        newPath = "/";
      }
      window.history.replaceState(null, "", newPath);
    });
  }
  /**
   * Replace current {@link window.URL} with a localized path, id and parameters from the given {@link PageRoute} without reloading the page.
   * Also replaces the current {@link window.history} entry with the new route.
   * If reloading of the page is wanted, use {@link redirectAsync} instead.
   *
   * @param pageRoute {@link PageRoute} from which to get route name, id and parameters.
   */
  static changeUrlWithRouteWithoutReloadAsync(pageRoute) {
    return __awaiter(this, void 0, void 0, function* () {
      //Hack. Without this invokeRedirectAsync will replaceState before this function and it will mess up history
      //Feel free to make better solution for this :)
      yield new Promise(callback => setTimeout(callback, 2));
      const url = PageRoute.toRelativePath(pageRoute);
      window.history.replaceState(pageRoute, "", url);
    });
  }
  static stopPropagation() {
    throw new Error(AthenaeumConstants.apiError);
  }
  static offline() {
    return __awaiter(this, void 0, void 0, function* () {
      yield PageRouteProvider.redirectAsync(BasePageDefinitions.offlineRoute, true);
    });
  }
  static error(serverError) {
    return __awaiter(this, void 0, void 0, function* () {
      // redirect to error page
      const route = new PageRoute(BasePageDefinitions.errorRouteName);
      route.parameters = {
        error: serverError
      };
      yield PageRouteProvider.redirectAsync(route, true);
    });
  }
  static exception(error, reactInfo = null, redirect = true) {
    return __awaiter(this, void 0, void 0, function* () {
      if (error && !ApiProvider.isApiError(error)) {
        const page = ch.findPage();
        const pageRouteName = page && page.routeName ? page.routeName : ``;
        const componentStack = reactInfo != null ? reactInfo.componentStack : "";
        const messageHashCode = `${pageRouteName}:${componentStack}:${error.stack}:${error.message}`.getHashCode();
        const stackOverflow = this._lastMessageHashCode == messageHashCode;
        const httpEndpoint = error.httpEndpoint || ``;
        const httpMethod = error.httpMethod || ``;
        if (stackOverflow) {
          console.warn(error);
          return false;
        }
        this._lastMessageHashCode = messageHashCode;
        const pageName = pageRouteName ? ` on page "${pageRouteName}"` : ``;
        const url = window.location.href;
        const apiDetails = httpEndpoint || httpMethod ? `\nAPI: ${httpMethod}:${httpEndpoint}\n` : ``;
        const debugDetails = `Unhandled JS exception occured${pageName} ("${url}"): "${error.message}"${apiDetails}\n${error.stack}\n${componentStack}.`;
        const serverError = {
          requestId: "",
          debugDetails: debugDetails
        };
        // do not await, just notification event
        setTimeout(() => this.onJsErrorAsync(serverError), 0);
        if (redirect) {
          //redirect to error page
          yield this.error(serverError);
        }
      }
      return true;
    });
  }
  static defaultRouteResolver(pathname) {
    var _a;
    const pageDefinitions = ServiceProvider.getService("IPageDefinitions");
    const routes = (_a = pageDefinitions === null || pageDefinitions === void 0 ? void 0 : pageDefinitions.getRoutes) === null || _a === void 0 ? void 0 : _a.call(pageDefinitions);
    if (!routes) {
      return null;
    }
    const parts = pathname.split("/").filter(route => route !== '');
    const pageName = parts[0];
    const secondUrlPart = parts[1];
    const longRoute = secondUrlPart ? `${pageName}/${secondUrlPart}` : null;
    let pageRoute = null;
    // Second URL part is not an Id.
    if (longRoute) {
      const longRouteKeys = [longRoute, longRoute.toUpperCase(), longRoute.toLowerCase()];
      for (let i = 0; i < longRouteKeys.length; i++) {
        const longRouteKey = longRouteKeys[i];
        if (routes.containsKey(longRouteKey)) {
          pageRoute = routes.getValue(longRouteKey);
          break;
        }
      }
    }
    // Second URL part is an Id.
    if (!pageRoute) {
      const pageNameKeys = [pageName, pageName.toUpperCase(), pageName.toLowerCase()];
      for (let i = 0; i < pageNameKeys.length; i++) {
        const pageNameKey = pageNameKeys[i];
        if (routes.containsKey(pageNameKey)) {
          pageRoute = routes.getValue(pageNameKey);
          pageRoute.id = secondUrlPart;
          break;
        }
      }
    }
    if (pageRoute) {
      pageRoute.parameters = queryString.parse(window.location.search);
    }
    return pageRoute;
  }
  /**
   * Get a {@link PageRoute} registered with the given URL, or null if not found.
   * If the URL contains two parts and no {@link PageRoute} is found with the full path, assigns the last part as an Id.
   *
   * @param pathname URL to resolve to a {@link PageRoute}.
   * @param defaultResolver - if true the default resolver will be used first;
   */
  static resolveRoute(pathname, defaultResolver = true) {
    let route = defaultResolver ? this.defaultRouteResolver(pathname) : null;
    const length = this._routeResolvers.length;
    for (let i = 0; i < length; i++) {
      if (route != null) {
        break;
      }
      route = this._routeResolvers[i](pathname);
    }
    return route;
  }
  static back() {
    window.history.back();
  }
  static forward() {
    window.history.forward();
  }
  static push(route, title = null, replace = false) {
    if (title) {
      document.title = title;
    }
    const stateTitle = title || route.name;
    if (replace) {
      window.history.replaceState(route, stateTitle);
    } else {
      window.history.pushState(route, stateTitle);
    }
    const context = ch.getContext();
    const routesAreEqual = PageRoute.isEqual(context.currentPage, route);
    if (!routesAreEqual) {
      this.onRedirect(route);
    }
  }
  static render(page, ref) {
    const pageDefinitions = ServiceProvider.getRequiredService("IPageDefinitions");
    return pageDefinitions.render(page, ref);
  }
  static registerRedirectCallback(callback) {
    this._redirectCallbacks.push(callback);
  }
  static registerRouteResolver(routeResolver) {
    this._routeResolvers.push(routeResolver);
  }
  static get isInitialPage() {
    return this._isInitialPage;
  }
}
PageRouteProvider._initialized = false;
PageRouteProvider._isInitialPage = false;
PageRouteProvider._lastMessageHashCode = 0;
PageRouteProvider._redirectCallbacks = [];
PageRouteProvider._routeResolvers = [];
/**
 * Should {@link PageRoute.parameters} be sent to API on {@link redirectAsync}.
 * Has no effect if {@link ILayoutPage.useRouting} is true, in which case the parameters are always sent.
 *
 * @default false
 */
PageRouteProvider.sendParametersOnRedirect = false;

var DataStorageType;
(function (DataStorageType) {
  DataStorageType[DataStorageType["Session"] = 0] = "Session";
  DataStorageType[DataStorageType["Page"] = 1] = "Page";
  DataStorageType[DataStorageType["Route"] = 2] = "Route";
})(DataStorageType || (DataStorageType = {}));
class UserInteractionDataStorage {
  constructor() {
    this._data = new Dictionary();
    this._initialized = false;
    this._key = null;
  }
  get key() {
    if (this._key != null) {
      return this._key;
    }
    const context = ch.findContext();
    let applicationName = context ? context.applicationName : null;
    if (!applicationName) {
      applicationName = window.location.host;
    }
    const sessionId = ch.getSessionId();
    this._key = `${applicationName}.${sessionId}.userInteractionDataStorage`;
    return this._key;
  }
  get data() {
    this.initialize();
    return this._data;
  }
  initialize() {
    if (!this._initialized) {
      this._initialized = true;
      const json = window.localStorage.getItem(this.key);
      if (json) {
        const data = JSON.parse(json);
        const destination = this._data;
        destination.table = data.table;
        destination.nElements = data.nElements;
      }
    }
  }
  save() {
    const json = JSON.stringify(this.data);
    try {
      window.localStorage.setItem(this.key, json);
    } catch (_a) {}
  }
  getKey(type, id) {
    const page = ch.findPage();
    return page === null || type === DataStorageType.Session ? id : type === DataStorageType.Route ? `${page.routeName}:${page.routeIndex}:${page.routeId}:${id}` : `${page.routeName}:${id}`;
  }
  set(id, value, type = DataStorageType.Page) {
    const key = this.getKey(type, id);
    this.data.setValue(key, value);
    this.save();
  }
  get(id, defaultValue = null, type = DataStorageType.Page) {
    const key = this.getKey(type, id);
    const value = this.data.getValue(key);
    return value != null ? value : defaultValue;
  }
  restore(id, to, type = DataStorageType.Page) {
    const key = this.getKey(type, id);
    const value = this.data.getValue(key);
    if (value != null && to != null) {
      Utility.copyTo(value, to);
    }
    return to;
  }
  clear(type) {
    if (type == null || type == DataStorageType.Session) {
      this.data.clear();
      this.save();
    } else {
      const keys = this.data.keys();
      const length = keys.length;
      if (length > 0) {
        const keyPattern = this.getKey(type, "");
        for (let i = 0; i < length; i++) {
          const key = keys[i];
          if (key.startsWith(keyPattern)) {
            this.data.remove(key);
          }
        }
        this.save();
      }
    }
  }
  reload() {
    this._initialized = false;
    this.initialize();
  }
  onAuthorize() {
    return __awaiter(this, void 0, void 0, function* () {
      this._initialized = false;
      this._key = null;
    });
  }
}
var UserInteractionDataStorage$1 = new UserInteractionDataStorage();

const MAX_ETAG_DATA_LENGTH_IN_BYTES = 200 * 1024;
class ApiProviderSyncContainer {
  constructor() {
    this.lock = new Mutex();
    this.queue = [];
    this.processing = false;
  }
}
class ApiProviderETagContainer {
  constructor() {
    this.response = null;
    this.timestamp = new Date().getTime();
    this.length = 0;
    this.lock = new Mutex();
  }
}
class ApiProviderETagKeyValue {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}
class ETagProvider {
  static get key() {
    var _a;
    return (_a = this._key) !== null && _a !== void 0 ? _a : this._key = `${window.location.host}.eTagProvider`;
  }
  static initialize() {
    if (!this._initialized) {
      this._initialized = true;
      const json = window.localStorage.getItem(this.key);
      if (json) {
        const restoredData = JSON.parse(json);
        const data = this._data;
        const dataObject = data;
        dataObject.table = restoredData.table;
        dataObject.nElements = restoredData.nElements;
        const items = data.values();
        const length = items.length;
        for (let i = 0; i < length; i++) {
          const item = items[i];
          item.lock = new Mutex();
          Utility.restoreDate(item.response);
        }
      }
    }
  }
  static getDataItems(data) {
    const items = [];
    data.forEach((key, value) => items.push(new ApiProviderETagKeyValue(key, value)));
    return items;
  }
  static invokeSave() {
    const data = this._data;
    let items = this.getDataItems(data);
    // Calculate response lengths and remove those that are too big
    const length = items.length;
    for (let i = 0; i < length; i++) {
      const item = items[i];
      const container = item.value;
      if (container.response != null && container.length == 0) {
        const responseJson = JSON.stringify(container.response);
        container.length = responseJson.length;
        if (container.length > MAX_ETAG_DATA_LENGTH_IN_BYTES) {
          const key = item.key;
          data.remove(key);
        }
      }
    }
    const json = JSON.stringify(data);
    try {
      window.localStorage.setItem(this.key, json);
    } catch (_a) {
      // Remove the obsolete responses
      let items = this.getDataItems(data);
      items.sortBy(item => item.value.timestamp);
      const countToRemove = Math.ceil(length / 2);
      for (let i = 0; i < countToRemove; i++) {
        const key = items[i].key;
        data.remove(key);
      }
      this.invokeSave();
    }
  }
  static save() {
    //setTimeout(() => this.invokeSave(), 0);
    this.invokeSave();
  }
  static getContainerAsync(key) {
    this.initialize();
    const data = this._data;
    return this._lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
      let dataItem = data.getValue(key);
      if (dataItem == null) {
        dataItem = new ApiProviderETagContainer();
        data.setValue(key, dataItem);
      }
      return dataItem;
    }));
  }
}
ETagProvider._data = new Dictionary();
ETagProvider._lock = new Mutex();
ETagProvider._key = null;
ETagProvider._initialized = false;
class ApiProvider {
  static getSynchronousContainerAsync(key) {
    return this._synchronousLock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
      let container = this._synchronousItems.getValue(key);
      if (!container) {
        container = new ApiProviderSyncContainer();
        this._synchronousItems.setValue(key, container);
      }
      return container;
    }));
  }
  static processSynchronouslyAsync(container) {
    return __awaiter(this, void 0, void 0, function* () {
      let actionToInvoke = null;
      yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        if (container.queue.length > 0 && !container.processing) {
          actionToInvoke = container.queue[0];
          container.queue.removeAt(0);
          container.processing = true;
        }
      }));
      if (actionToInvoke != null) {
        try {
          // @ts-ignore
          yield actionToInvoke(() => container.queue.length == 0);
        } catch (error) {
          yield PageRouteProvider.exception(error);
        } finally {
          yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
            container.processing = false;
          }));
          yield this.processSynchronouslyAsync(container);
        }
      }
    });
  }
  static invokeSynchronouslyPostAsync(isCompleted, endpoint, request = null, caller = null, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (callback) {
        const response = yield this.postAsync(endpoint, request, caller);
        if (isCompleted()) {
          yield callback(response);
        }
      } else {
        yield this.postAsync(endpoint, request, caller);
      }
    });
  }
  static invokeSynchronouslyActionAsync(isCompleted, action, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      if (callback) {
        const response = yield action();
        if (isCompleted()) {
          yield callback(response);
        }
      } else {
        yield action();
      }
    });
  }
  static invokeSynchronouslyAsync(key, action, replace = false, background = true) {
    return __awaiter(this, void 0, void 0, function* () {
      const container = yield this.getSynchronousContainerAsync(key);
      yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        const length = container.queue.length;
        // The processing action is not in the queue!
        //replace &&= (length > 0) && ((!container.processing) || (length > 1));
        replace && (replace = length > 0);
        if (replace) {
          container.queue[length - 1] = action;
        } else {
          container.queue.push(action);
        }
      }));
      if (background) {
        setTimeout(() => this.processSynchronouslyAsync(container), 0);
      } else {
        yield this.processSynchronouslyAsync(container);
      }
    });
  }
  static invokeLoadingCallbacksAsync(obsolete) {
    return __awaiter(this, void 0, void 0, function* () {
      const isLoading = this.isLoading;
      if (isLoading != obsolete) {
        yield Utility.forEachAsync(this._loadingCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
          return yield callback(isLoading);
        }));
      }
    });
  }
  static setAutoIsSpinningAsync(isSpinning, caller) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._manualSpinning) {
        const isLoading = this.isLoading;
        this._isSpinning += isSpinning ? +1 : -1;
        if (caller) {
          if (caller.hasSpinner()) {
            yield caller.setSpinnerAsync(isSpinning);
          } else {
            const layout = ch.getLayout();
            yield layout.setSpinnerAsync(isSpinning);
          }
        }
        yield this.invokeLoadingCallbacksAsync(isLoading);
      }
    });
  }
  static setManualIsSpinningAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      const isLoading = this.isLoading;
      this._manualSpinning = isSpinning;
      const layout = ch.getLayout();
      yield layout.setSpinnerAsync(isSpinning);
      yield this.invokeLoadingCallbacksAsync(isLoading);
    });
  }
  static setHeaders(httpRequest, setContentType = true) {
    const headers = httpRequest.headers ? new Headers(httpRequest.headers) : new Headers();
    //Content Type
    if (setContentType) {
      headers.set("Content-Type", "application/json");
    }
    //XSRT Token
    const xsrfToken = ch.getXsrfToken();
    if (xsrfToken != null) {
      headers.set("xsrf-token", xsrfToken);
    }
    httpRequest.credentials = "include";
    httpRequest.headers = headers;
  }
  static ignoreException(endpoint) {
    return endpoint.endsWith("/OnJsError") || endpoint.endsWith("/OnRedirect");
  }
  static fetchAsync(endpoint, httpRequest, caller) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield this.setAutoIsSpinningAsync(true, caller);
        //const httpResponse: Response = await fetch(endpoint, httpRequest);
        const httpResponse = yield Utility.reTryAsync(() => fetch(endpoint, httpRequest));
        this._lastRequestPassed = true;
        const apiResponse = yield this.processServerResponseAsync(httpResponse);
        // const dataResponse: TResponse = ((apiResponse != null) ? apiResponse : {}) as TResponse;
        return apiResponse;
      } catch (exception) {
        const error = exception;
        const ignore = ApiProvider.isApiError(error) || ApiProvider.ignoreException(endpoint);
        if (!ignore) {
          this._lastRequestPassed = null;
          // Process error:                
          if (this.offline) {
            yield PageRouteProvider.offline();
          } else {
            if (error) {
              const e = error;
              e.httpEndpoint = endpoint;
              e.httpMethod = httpRequest.method;
            }
            yield PageRouteProvider.exception(error);
          }
        }
        throw new Error(AthenaeumConstants.apiError);
      } finally {
        yield this.setAutoIsSpinningAsync(false, caller);
      }
    });
  }
  static isAntiForgeryError(httpResponse, jsonResponse) {
    //{ "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1", "title": "Bad Request", "status": 400, "traceId": "0HLLSRLLJPHV2:00000009" }
    return httpResponse.status === AthenaeumConstants.badRequestStatusCode && jsonResponse != null && jsonResponse.title === "Bad Request" && jsonResponse.type === "https://tools.ietf.org/html/rfc7231#section-6.5.1";
  }
  static parseJsonError(jsonResponse) {
    let requestId = "";
    let debugDetails = "";
    if (jsonResponse != null) {
      if (jsonResponse.traceId) {
        requestId = jsonResponse.traceId;
      }
      if (jsonResponse.title) {
        debugDetails = jsonResponse.title + "\n";
      }
      if (jsonResponse.errors && typeof jsonResponse.errors === "object") {
        let errors = jsonResponse.errors;
        for (let propertyName in errors) {
          if (errors.hasOwnProperty(propertyName)) {
            let property = errors[propertyName];
            if (property != null && property.length != null) {
              if (typeof property === "string") {
                debugDetails += property + "\n";
              } else {
                debugDetails += property.join("\n");
              }
            }
          }
        }
      }
    }
    return {
      requestId: requestId,
      debugDetails: debugDetails
    };
  }
  static processServerResponseAsync(httpResponse) {
    return __awaiter(this, void 0, void 0, function* () {
      const textResponse = yield httpResponse.text();
      const endpoint = httpResponse.url;
      if (ApiProvider.ignoreException(endpoint)) {
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status === AthenaeumConstants.notFoundStatusCode) {
        const serverError = {
          requestId: "",
          debugDetails: `Requested api action not found (404): "${endpoint}".\nServer response:\n${textResponse.trim()}`
        };
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      const hasResponse = textResponse.length > 0;
      const isHtml = hasResponse && (textResponse.startsWith("<!DOCTYPE html>") || textResponse.startsWith("<!doctype html>"));
      if (isHtml) {
        const isMaintenanceOrBlocked = textResponse.indexOf("Support") > 0 || textResponse.indexOf("Site Maintenance") > 0;
        if (isMaintenanceOrBlocked) {
          ch.refresh();
        } else if (!this.offline) {
          const offlineOrRequestIsTooBig = endpoint.endsWith("offline.html") && httpResponse.status == 200;
          const debugDetails = offlineOrRequestIsTooBig ? `Server returned HTML instead of JSON response, probably server is offline or request body is too big.` : `Server returned HTML instead of JSON response, probably requested api action not found.`;
          const serverError = {
            requestId: "",
            debugDetails: debugDetails + `\nEndpoint: "${endpoint}"\nServer response code: "${httpResponse.status}".\nServer response:\n${textResponse.trim()}}`
          };
          yield PageRouteProvider.error(serverError);
        }
        throw new Error(AthenaeumConstants.apiError);
      }
      const jsonResponse = hasResponse ? JSON.parse(textResponse) : null;
      if (httpResponse.status === AthenaeumConstants.unauthorizedStatusCode || ApiProvider.isAntiForgeryError(httpResponse, jsonResponse)) {
        yield ch.reinitializeContextAsync();
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status === AthenaeumConstants.forbiddenStatusCode) {
        const page = ch.findPage();
        const user = ch.findUser();
        const username = user ? user.username : "unauthorized";
        const source = page ? page.routeName : "unknown";
        const mode = ch.isDevelopmentVS ? "DevelopmentVS" : ch.isDevelopment ? "Development" : "Production";
        const message = `API call failed\nAccess denied: \"FORBIDDEN (403)\"\nSource: "${source}"\nUser: "${username}".\nEndpoint: "${endpoint}"\nMode: \"${mode}\".`;
        console.warn(message);
        if (!ch.isDevelopment) {
          UserInteractionDataStorage$1.clear();
          yield ch.reinitializeContextAsync();
          throw new Error(AthenaeumConstants.apiError);
        }
        const serverError = {
          requestId: "",
          debugDetails: message
        };
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status === AthenaeumConstants.badRequestStatusCode) {
        const serverError = ApiProvider.parseJsonError(jsonResponse);
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status !== AthenaeumConstants.okStatusCode) {
        const serverError = {
          requestId: "",
          debugDetails: `Endpoint: "${endpoint}"\nServer response status code: "${httpResponse.status}".`
        };
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      if (jsonResponse != null) {
        const responseContainer = jsonResponse;
        if (responseContainer && responseContainer.isResponseContainer) {
          const value = responseContainer.value;
          if (responseContainer.unauthorized) {
            yield ch.reinitializeContextAsync();
            throw new Error(AthenaeumConstants.apiError);
          }
          const timezoneOffset = ch.timezoneOffset;
          if (timezoneOffset != null) {
            const isNewTimezone = timezoneOffset != Utility.timezoneOffset;
            if (isNewTimezone) {
              yield ch.reinitializeContextAsync();
              throw new Error(AthenaeumConstants.apiError);
            }
          }
          if (responseContainer.versionId) {
            const currentVersion = ch.versionId;
            const isNewVersion = currentVersion != null && currentVersion != responseContainer.versionId;
            if (isNewVersion) {
              ch.refresh();
              throw new Error(AthenaeumConstants.apiError);
            }
          }
          if (responseContainer.context) {
            yield ch.setContextAsync(responseContainer.context);
          }
          if (responseContainer.error != null) {
            yield PageRouteProvider.error(responseContainer.error);
            throw new Error(AthenaeumConstants.apiError);
          }
          if (responseContainer.redirect) {
            yield PageRouteProvider.redirectAsync(responseContainer.redirect, true);
          }
          if (responseContainer.alert) {
            yield ch.alertAsync(responseContainer.alert);
          }
          if (value != null) {
            Utility.restoreDate(value);
          }
          return value;
        }
      }
      return jsonResponse;
    });
  }
  static invokeWithForcedSpinnerAsync(action, eternal = false) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield this.setManualIsSpinningAsync(true);
        const result = yield action();
        if (!eternal) {
          yield this.setManualIsSpinningAsync(false);
        }
        return result;
      } catch (e) {
        yield this.setManualIsSpinningAsync(false);
        throw e;
      }
    });
  }
  static registerIsLoadingCallback(callback) {
    this._loadingCallbacks.push(callback);
  }
  static unRegisterIsLoadingCallback(callback) {
    const index = this._loadingCallbacks.indexOf(callback);
    if (index !== -1) {
      this._loadingCallbacks.splice(index, 1);
    }
  }
  static get offline() {
    return this._lastRequestPassed !== true && (navigator && !navigator.onLine || window.navigator && !window.navigator.onLine);
  }
  static get isLoading() {
    return this._manualSpinning || this._isSpinning > 0;
  }
  /**
   * Make an HTTP GET-request.
   *
   * @param endpoint Address where to send the GET request.
   * @param caller {@link IBaseComponent} making the GET-request. A spinner will be automatically set to this component,
   *               unless its {@link IBaseComponent.hasSpinner} returns false, in which case the spinner will be set to the current {@link ILayoutPage}.
   */
  static getAsync(endpoint, caller) {
    return __awaiter(this, void 0, void 0, function* () {
      const httpRequest = {
        url: endpoint,
        method: "GET"
      };
      this.setHeaders(httpRequest);
      return this.fetchAsync(endpoint, httpRequest, caller);
    });
  }
  static postFileAsync(endpoint, request = null, caller = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const formData = new FormData();
      formData.append("file", request);
      const httpRequest = {
        url: endpoint,
        body: formData,
        method: "POST"
      };
      this.setHeaders(httpRequest, false);
      return this.fetchAsync(endpoint, httpRequest, caller);
    });
  }
  /**
   * Makes an HTTP POST-request.
   *
   * @param endpoint Address where to send the POST request.
   * @param request Body of the POST-request.
   * @param cache The optional parameter for response caching
   * @param caller {@link IBaseComponent} making the POST-request. A spinner will be automatically set to this component,
   * unless its {@link IBaseComponent.hasSpinner} returns false, in which case the spinner will be set to the current {@link ILayoutPage}.
   * @param timeout The optional parameter in seconds
   */
  static postAsync(endpoint, request = null, caller = null, cache = false, timeout = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const supportsETag = request != null && request.isETagRequest;
      return supportsETag ? this.invokeEtagPostAsync(endpoint, request, caller, cache, null, timeout) : this.invokePostAsync(endpoint, request, caller, cache, timeout);
    });
  }
  static invokeEtagPostAsync(endpoint, request, caller, cache, externalKey = null, timeout = null) {
    return __awaiter(this, void 0, void 0, function* () {
      let key;
      if (externalKey) {
        key = externalKey;
      } else {
        const requestHashCode = Utility.getHashCode(request);
        key = `${ch.findUsername()}:${requestHashCode}:${endpoint.toLowerCase()}`;
      }
      if (cache == true || cache > 0) {
        const ttl = typeof cache === "number" ? cache : 0;
        return PageCacheProvider.getAsync(key, () => this.invokeEtagPostAsync(endpoint, request, caller, false, key, timeout), ttl);
      }
      const container = yield ETagProvider.getContainerAsync(key);
      return yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        const data = container.response;
        request.eTag = data != null ? data.eTag : null;
        const response = yield this.invokePostAsync(endpoint, request, caller, 0, timeout);
        if (request.eTag && (response == null || response.eTag == request.eTag)) {
          return data;
        }
        if (response != null && response.eTag) {
          container.response = response;
          ETagProvider.save();
        }
        return response;
      }));
    });
  }
  static invokePostAsync(endpoint, request = null, caller, cache, timeout = null) {
    if (cache === true || cache > 0) {
      const requestHashCode = Utility.getHashCode(request);
      const key = `${requestHashCode}:${endpoint.toLowerCase()}`;
      const ttl = typeof cache === "number" ? cache : 0;
      return PageCacheProvider.getAsync(key, () => this.invokePostAsync(endpoint, request, caller, false, timeout), ttl);
    }
    request = request != null ? request : {};
    const json = JSON.stringify(request);
    let signal = undefined;
    let timer = undefined;
    if (timeout != null && timeout > 0) {
      const controller = new AbortController();
      signal = controller.signal;
      timer = setTimeout(() => controller.abort(), 1000 * timeout);
    }
    const httpRequest = {
      url: endpoint,
      body: json,
      method: "POST",
      signal: signal
    };
    this.setHeaders(httpRequest);
    try {
      return this.fetchAsync(endpoint, httpRequest, caller);
    } finally {
      if (timer) {
        clearTimeout(timer);
      }
    }
  }
  /**
   * Makes an HTTP POST-request on background. Cannot return any data. Multiple requests to the same endpoint execute in sequence.
   *
   * @param endpoint Address where to send the POST request.
   * @param request Body of the POST-request.
   * @param caller {@link IBaseComponent} making the POST-request. A spinner will be automatically set to this component,
   *               unless its {@link IBaseComponent.hasSpinner} returns false, in which case the spinner will be set to the current {@link ILayoutPage}.
   * @param replace The latest request has priority, the last request overrides the previous request in a queue if parameter is true (false by default).
   * @param callback The callback to process response if needed, is called after the post is successfully sent
   */
  static backgroundPostAsync(endpoint, request = null, caller = null, replace = false, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSynchronouslyAsync(endpoint, isCompleted => this.invokeSynchronouslyPostAsync(isCompleted, endpoint, request, caller, callback), replace, true);
    });
  }
  static backgroundActionAsync(name, action, replace = false, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeSynchronouslyAsync(name, isCompleted => this.invokeSynchronouslyActionAsync(isCompleted, action, callback), replace, true);
    });
  }
  static isApiError(error) {
    return error && (error.name == AthenaeumConstants.apiError || error.message == AthenaeumConstants.apiError);
  }
}
ApiProvider._lastRequestPassed = null;
ApiProvider._isSpinning = 0;
ApiProvider._manualSpinning = false;
ApiProvider._loadingCallbacks = [];
ApiProvider._synchronousItems = new Dictionary();
ApiProvider._synchronousLock = new Mutex();

class JQueryUtility {
  static get $() {
    return this._jQuery || (this._jQuery = window.$ || $);
  }
  static getNode(id) {
    return typeof id === "string" ? this.$(`#${id}`) : id;
  }
  static outerWidth(id, includeMargin = true) {
    var _a;
    return (_a = this.getNode(id).outerWidth(includeMargin)) !== null && _a !== void 0 ? _a : 0;
  }
  static scrollTop(id) {
    var _a;
    return (_a = this.getNode(id).scrollTop()) !== null && _a !== void 0 ? _a : 0;
  }
  static innerWidth(id) {
    var _a;
    return (_a = this.getNode(id).innerWidth()) !== null && _a !== void 0 ? _a : 0;
  }
  static outerHeight(id, includeMargin = true) {
    var _a;
    return (_a = this.getNode(id).outerHeight(includeMargin)) !== null && _a !== void 0 ? _a : 0;
  }
  static innerHeight(id) {
    var _a;
    return (_a = this.getNode(id).innerHeight()) !== null && _a !== void 0 ? _a : 0;
  }
  static offsetLeft(id, includeMargin = true) {
    var _a, _b;
    const node = this.getNode(id);
    let offsetLeft = (_b = (_a = node.offset()) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0;
    if (includeMargin) {
      const marginLeft = parseInt(node.css("margin-left")) || 0;
      offsetLeft -= marginLeft;
    }
    return offsetLeft;
  }
  static offsetRight(id, includeMargin = true) {
    return JQueryUtility.viewportWidth() - this.offsetLeft(id, includeMargin) - this.outerWidth(id, includeMargin);
  }
  static offsetTop(id, includeMargin) {
    var _a, _b;
    const node = this.getNode(id);
    let offsetTop = (_b = (_a = node.offset()) === null || _a === void 0 ? void 0 : _a.top) !== null && _b !== void 0 ? _b : 0;
    if (includeMargin) {
      const marginTop = parseInt(node.css("margin-top")) || 0;
      offsetTop -= marginTop;
    }
    return offsetTop;
  }
  // public static offsetBottom(id: string): number {
  //     return this.documentHeight() - this.offsetTop(id);
  // }
  static positionLeft(id) {
    var _a;
    return (_a = this.getNode(id).position()) === null || _a === void 0 ? void 0 : _a.left;
  }
  static positionRight(id) {
    return this.documentWidth() - this.positionLeft(id);
  }
  static positionTop(id) {
    var _a;
    return (_a = this.getNode(id).position()) === null || _a === void 0 ? void 0 : _a.top;
  }
  static positionBottom(id) {
    return this.documentHeight() - this.positionTop(id);
  }
  static viewportLeft(id) {
    return this.positionLeft(id) - this.viewportScrollLeft();
  }
  static viewportRight(id) {
    return this.viewportWidth() - this.positionLeft(id);
  }
  static viewportTop(id) {
    return this.positionTop(id) - this.viewportScrollTop();
  }
  static viewportBottom(id) {
    return this.viewportHeight() - this.positionTop(id);
  }
  /**
   * Width of the visible part of the screen in pixels
   */
  static viewportWidth() {
    return window.innerWidth;
  }
  /**
   * Height of the visible part of the screen in pixels
   */
  static viewportHeight() {
    return window.innerHeight;
  }
  /**
   * Full width in pixels of the whole document, including the hidden part behind the horizontal scroll.
   */
  static documentWidth() {
    return window.innerWidth;
  }
  /**
   * Full height in pixels of the whole document, including the hidden part behind the vertical scroll.
   */
  static documentHeight() {
    return window.innerHeight;
  }
  static viewportOffsetLeft() {
    return this.viewportScrollLeft();
  }
  static viewportOffsetTop() {
    return this.viewportScrollTop();
  }
  static viewportScrollLeft() {
    var _a;
    return (_a = this.$(document).scrollLeft()) !== null && _a !== void 0 ? _a : 0;
  }
  static viewportScrollTop() {
    var _a;
    return (_a = this.$(document).scrollTop()) !== null && _a !== void 0 ? _a : 0;
  }
}

var DocumentEventType;
(function (DocumentEventType) {
  DocumentEventType[DocumentEventType["Mousedown"] = 0] = "Mousedown";
  DocumentEventType[DocumentEventType["Keydown"] = 1] = "Keydown";
  DocumentEventType[DocumentEventType["Resize"] = 2] = "Resize";
  DocumentEventType[DocumentEventType["Scroll"] = 3] = "Scroll";
  DocumentEventType[DocumentEventType["IsLoading"] = 4] = "IsLoading";
})(DocumentEventType || (DocumentEventType = {}));
class DocumentEventsProvider {
  getContainer(event) {
    switch (event) {
      case DocumentEventType.Mousedown:
        return this._mousedownEvents;
      case DocumentEventType.Keydown:
        return this._keydownEvents;
      case DocumentEventType.Resize:
        return this._resizeEvents;
      case DocumentEventType.Scroll:
        return this._scrollEvents;
      case DocumentEventType.IsLoading:
        return this._isLoadingEvents;
      default:
        throw Error(`DocumentEventsProvider. Unknown document event type "${event}". Container cannot be found.`);
    }
  }
  callAsync(event, e) {
    return __awaiter(this, void 0, void 0, function* () {
      const container = this.getContainer(event);
      const callbacks = container.values();
      const length = callbacks.length;
      for (let i = 0; i < length; i++) {
        try {
          yield callbacks[i](e);
        } catch (_a) {}
      }
    });
  }
  constructor() {
    this._mousedownEvents = new Dictionary();
    this._keydownEvents = new Dictionary();
    this._resizeEvents = new Dictionary();
    this._scrollEvents = new Dictionary();
    this._isLoadingEvents = new Dictionary();
    document.addEventListener("mousedown", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Mousedown, e);
    }), false);
    document.addEventListener("keydown", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Keydown, e);
    }), false);
    window.addEventListener("resize", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Resize, e);
    }), false);
    window.addEventListener("scroll", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Scroll, e);
    }), false);
    //window.addEventListener("offline", async (e) => await ch.alertErrorAsync("You are offline", false, true), false);
    //window.addEventListener("online", async (e) => await ch.flyoutMessageAsync("You are back online"), false);
    ApiProvider.registerIsLoadingCallback(() => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.IsLoading, null);
    }));
  }
  register(id, event, callback) {
    const container = this.getContainer(event);
    container.setValue(id, callback);
  }
  unregister(id, event) {
    const container = this.getContainer(event);
    container.remove(id);
  }
}
var DocumentEventsProvider$1 = new DocumentEventsProvider();

/**
 * Base class for all components.
 */
class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    this._asGlobalClick = this.asGlobalClick();
    this._asGlobalKeydown = this.asGlobalKeydown();
    this._asGlobalResize = this.asGlobalResize();
    this._asGlobalScroll = this.asGlobalScroll();
    this._childComponentIds = new Dictionary();
    this._childComponentRefs = [];
    this._isMounted = false;
    this._isSpinning = false;
    const id = props ? props.id : ch.getComponentId();
    this.id = id != null ? id : ch.getComponentId();
    this.typeName = this.constructor.name;
    ch.register(this);
  }
  asGlobalClick() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalClick === "function") {
      return instance;
    }
    return null;
  }
  asGlobalKeydown() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalKeydown === "function") {
      return instance;
    }
    return null;
  }
  asGlobalResize() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalResize === "function") {
      return instance;
    }
    return null;
  }
  asGlobalScroll() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalScroll === "function") {
      return instance;
    }
    return null;
  }
  clone(element) {
    if (BaseComponent.isComponent(element)) {
      const expandedProps = this.extendChildProps(element);
      const id = element.props.id || ch.getComponentId();
      let ref = element.ref;
      if (ref == null) {
        ref = this._childComponentIds.getValue(id) || null;
        if (ref == null) {
          ref = React.createRef();
          this._childComponentIds.setValue(id, ref);
        }
      }
      this._childComponentRefs.push(ref);
      const newProps = Object.assign(Object.assign(Object.assign({}, element.props), {
        ref: ref,
        id: id
      }), expandedProps);
      return React.cloneElement(element, newProps);
    }
    return element;
  }
  /**
   * @return null
   */
  extendChildProps(element) {
    return null;
  }
  /**
   * @param element Value to check for componentness.
   * @return Is the value a component.
   */
  static isComponent(element) {
    if (element != null) {
      if (element.isComponent !== undefined && typeof element.isComponent === "function" && element.isComponent()) {
        return true;
      }
      let prototype = element.type;
      while (prototype && prototype.name && prototype.name !== Object.name) {
        if (prototype.name === BaseComponent.name) {
          return true;
        }
        prototype = Object.getPrototypeOf(prototype);
      }
    }
    return false;
  }
  /**
   * @return {@link JQueryUtility.$}
   */
  get JQuery() {
    return JQueryUtility.$;
  }
  /**
   * @return The {@link BaseComponent}'s node in DOM as {@link jQuery}.
   */
  getNode() {
    return this.JQuery(`#${this.id}`);
  }
  /**
   * @see ILayoutPage.useRouting
   */
  get useRouting() {
    // noinspection PointlessBooleanExpressionJS - useRouting can be undefined.
    return ch.getLayout().useRouting === true;
  }
  get children() {
    this._childComponentRefs = [];
    let children = this.props.children;
    if (children && children.type && children.type.toString && children.type.toString() === "Symbol(react.fragment)") {
      children = children.props.children;
    }
    const clone = React.Children.map(children, child => {
      const element = child;
      return this.clone(element);
    });
    return clone || [];
  }
  /**
   *  Components have constructor.name but it will get renamed when project is built for production.
   *  With a static constant value on component we can identify which component is in children.
   *  Normally there is one typeName in BaseComponent and it's a instance string value.
   *  But this type extend is for static class value.
   *
   *  @see children
   */
  get childrenWithType() {
    return this.children;
  }
  /**
   * @see ch.mobileApp
   */
  get mobileApp() {
    return ch.mobileApp;
  }
  /**
   * @see ch.isAuthenticated
   */
  get isAuthenticated() {
    return ch.isAuthenticated;
  }
  /**
   * @see ApiProvider.postFileAsync
   */
  postFileAsync(endpoint, file = null) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield ApiProvider.postFileAsync(endpoint, file, this);
    });
  }
  postCacheAsync(endpoint, ttl = 0) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield PageCacheProvider.getAsync(endpoint, () => __awaiter(this, void 0, void 0, function* () {
        return yield this.postAsync(endpoint);
      }), ttl);
    });
  }
  /**
   * Call {@link reRenderAsync} without awaiting.
   */
  reRender() {
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderAsync();
  }
  /**
   * @param id Id of the child {@link IBaseComponent} to find.
   * @return A child {@link IBaseComponent} with the given id, or null if not found.
   */
  findComponent(id) {
    return this.childComponents.find(component => component.id === id);
  }
  /**
   * @see Utility.copyTo
   */
  copyTo(from, ...to) {
    Utility.copyTo(from, ...to);
  }
  /**
   * @see Utility.css
   */
  css(...params) {
    return Utility.css(...params);
  }
  cssIf(className, add, css) {
    const items = className ? className.split(" ") : [];
    const index = items.indexOf(css);
    if (add) {
      if (index === -1) {
        items.push(css);
        return items.join(" ");
      }
    } else {
      if (index !== -1) {
        items.splice(index, 1);
        return items.join(" ");
      }
    }
    return className || "";
  }
  /**
   * @see ReactUtility.toSingleLine
   */
  toSingleLine(text) {
    return ReactUtility.toSingleLine(text);
  }
  /**
   * @see ReactUtility.toMultiLines
   */
  toMultiLines(text) {
    return ReactUtility.toMultiLines(text);
  }
  /**
   * Shows that the component is visible, fits to the viewport, and is not hidden above the scrolled context.
   */
  isInView(fullyInView = true) {
    var _a, _b, _c, _d, _e;
    const windowNode = this.JQuery(window);
    const node = this.getNode();
    const pageTop = (_a = windowNode.scrollTop()) !== null && _a !== void 0 ? _a : 0;
    const pageBottom = pageTop + ((_b = windowNode.height()) !== null && _b !== void 0 ? _b : 0);
    const elementTop = (_d = (_c = node.offset()) === null || _c === void 0 ? void 0 : _c.top) !== null && _d !== void 0 ? _d : 0;
    const elementBottom = elementTop + ((_e = node.height()) !== null && _e !== void 0 ? _e : 0);
    return fullyInView ? pageTop < elementTop && pageBottom > elementBottom : elementTop <= pageBottom && elementBottom >= pageTop;
  }
  /**
   * Called by {@link componentWillMount}.
   */
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  // IReactComponent
  get isMounted() {
    return this._isMounted;
  }
  componentWillMount() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeAsync();
    });
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      this._isMounted = true;
      if (this._asGlobalClick) {
        const handler = this._asGlobalClick;
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Mousedown, e => handler.onGlobalClick(e));
      }
      if (this._asGlobalKeydown) {
        const handler = this._asGlobalKeydown;
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Keydown, e => handler.onGlobalKeydown(e));
      }
      if (this._asGlobalResize) {
        const handler = this._asGlobalResize;
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Resize, e => handler.onGlobalResize(e));
      }
      if (this._asGlobalScroll) {
        const handler = this._asGlobalScroll;
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Scroll, e => handler.onGlobalScroll(e));
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  componentWillUnmount() {
    return __awaiter(this, void 0, void 0, function* () {
      this._isMounted = false;
      this._isSpinning = false;
      if (this._asGlobalClick) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Mousedown);
      }
      if (this._asGlobalKeydown) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Keydown);
      }
      if (this._asGlobalResize) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Resize);
      }
      if (this._asGlobalScroll) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Scroll);
      }
    });
  }
  // ISpinner
  /**
   * @inheritDoc
   *
   * NOTE: Must be overridden to return true in order to enable spinner-related functionalities {@link isSpinning} and {@link setSpinnerAsync} of the {@link BaseComponent}.
   *
   * @return false
   */
  hasSpinner() {
    return false;
  }
  /**
   * @inheritDoc
   *
   * NOTE: Can return true only if {@link hasSpinner} is overridden to return true.
   */
  isSpinning() {
    return this.hasSpinner() && this._isSpinning;
  }
  /**
   * @inheritDoc
   *
   * NOTE: Works only if {@link hasSpinner} is overridden to return true.
   */
  setSpinnerAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasSpinner() && isSpinning !== this._isSpinning) {
        this._isSpinning = isSpinning;
        yield this.reRenderAsync();
      }
    });
  }
  // IBaseComponent
  get childComponents() {
    const childComponents = [];
    childComponents.push(...this._childComponentRefs.filter(ref => BaseComponent.isComponent(ref.current)).map(ref => ref.current));
    return childComponents;
  }
  /**
   * @inheritDoc
   * @see ch.desktop
   */
  get desktop() {
    return ch.desktop;
  }
  /**
   * @inheritDoc
   * @see ch.mobile
   */
  get mobile() {
    return ch.mobile;
  }
  /**
   * @inheritDoc
   * @see ch.getPage
   */
  getPage() {
    return ch.getPage();
  }
  /**
   * @inheritDoc
   * @return true
   */
  isComponent() {
    return true;
  }
  outerHeight(includeMargin = true) {
    const node = this.getNode();
    return (node === null || node === void 0 ? void 0 : node.outerHeight(includeMargin)) || 0;
  }
  outerWidth(includeMargin = true) {
    const node = this.getNode();
    return (node === null || node === void 0 ? void 0 : node.outerWidth(includeMargin)) || 0;
  }
  /**
   * @inheritDoc
   * @see ApiProvider.getAsync
   */
  getAsync(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
      return ApiProvider.getAsync(endpoint, this);
    });
  }
  /**
   * @inheritDoc
   * @see ApiProvider.postAsync
   */
  postAsync(endpoint, request = null, cache = false, timeout = null) {
    return __awaiter(this, void 0, void 0, function* () {
      return ApiProvider.postAsync(endpoint, request, this, cache, timeout);
    });
  }
  /**
   * @inheritDoc
   * @see React.Component.forceUpdate
   *
   * NOTE: effective only if the {@link BaseComponent} is mounted.
   */
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.forceUpdate();
      }
    });
  }
}

/**
 * Base class for pages.
 */
class BasePage extends BaseComponent {
  asIsLoading() {
    const instance = this;
    if (instance != null && typeof instance.onIsLoading === "function") {
      return instance;
    }
    return null;
  }
  setPageUrlAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.getPage();
      if (!(page === null || page === void 0 ? void 0 : page.automaticUrlChange) || !this.useRouting) {
        return;
      }
      document.title = page.getTitle();
      yield PageRouteProvider.changeUrlWithRouteWithoutReloadAsync(page.route);
    });
  }
  constructor(props = null) {
    super(props || {});
    this._asIsLoading = this.asIsLoading();
  }
  reloadTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasTopNav) {
        yield ch.reloadTopNavAsync();
      }
    });
  }
  reRenderTopNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasTopNav) {
        yield ch.reRenderTopNavAsync();
      }
    });
  }
  reRenderTopNav() {
    if (this.hasTopNav) {
      ch.reRenderTopNav();
    }
  }
  reloadLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasLeftNav) {
        yield ch.reloadLeftNavAsync();
      }
    });
  }
  reRenderLeftNavAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasTopNav) {
        yield ch.reRenderLeftNavAsync();
      }
    });
  }
  reRenderLeftNav() {
    if (this.hasTopNav) {
      ch.reRenderLeftNav();
    }
  }
  /**
   * @return User of current {@link IUserContext}.
   * @see ch.getContext
   */
  findUser() {
    return ch.getContext().user || null;
  }
  /**
   * @return Username of current {@link IUserContext}.
   * @see ch.getContext
   */
  get username() {
    return ch.getContext().username || null;
  }
  /**
   * @return Is {@link username} defined.
   */
  get isAuthorized() {
    return !!this.username;
  }
  /**
   * @see ch.flyoutErrorAsync
   */
  static flyoutErrorAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.flyoutErrorAsync(message);
    });
  }
  /**
   * @see ch.flyoutMessageAsync
   */
  static flyoutMessageAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.flyoutMessageAsync(message);
    });
  }
  /**
   * @see ch.alertWarningAsync
   */
  alertWarningAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.alertWarningAsync(message, autoClose, flyout);
    });
  }
  /**
   * @see ch.flyoutWarningAsync
   */
  static flyoutWarningAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.flyoutWarningAsync(message);
    });
  }
  /**
   * @return ""
   */
  getManual() {
    return "";
  }
  // BaseComponent
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this._asIsLoading) {
        DocumentEventsProvider$1.register(this.id, DocumentEventType.IsLoading, () => __awaiter(this, void 0, void 0, function* () {
          return yield this._asIsLoading.onIsLoading();
        }));
      }
      yield this.setPageUrlAsync();
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this._asIsLoading) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.IsLoading);
      }
      yield _super.componentWillUnmount.call(this);
    });
  }
  // IBasePage
  /**
   * @inheritDoc
   *
   * Does nothing and returns.
   * @return true
   */
  onSwipeHandlerAsync(direction) {
    return __awaiter(this, void 0, void 0, function* () {
      return true;
    });
  }
  /**
   * @inheritDoc
   * @see ch.alertAsync
   */
  alertAsync(alert) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.alertAsync(alert);
    });
  }
  /**
   * @inheritDoc
   * @see ch.alertErrorAsync
   */
  alertErrorAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.alertErrorAsync(message, autoClose, flyout);
    });
  }
  /**
   * @inheritDoc
   * @see ch.alertMessageAsync
   */
  alertMessageAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.alertMessageAsync(message, autoClose, flyout);
    });
  }
  /**
   * @inheritDoc
   * @see ch.hideAlertAsync
   */
  hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.hideAlertAsync();
    });
  }
  /**
   * @inheritDoc
   * @see IPageContainer.confirmAsync
   */
  confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      return pageContainer != null && (yield pageContainer.confirmAsync(title));
    });
  }
  messageBoxAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      return pageContainer != null ? yield pageContainer.messageBoxAsync(titleOrModel, caption, buttons, icon) : DialogResult.None;
    });
  }
  documentPreviewAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer != null) {
        yield pageContainer.documentPreviewAsync(model);
      }
    });
  }
  descriptionAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer != null) {
        yield pageContainer.descriptionAsync(containerId, model);
      }
    });
  }
  /**
   * @inheritDoc
   *
   * Does nothing and returns.
   * @return true
   */
  beforeRedirectAsync(nextRoute, innerRedirect) {
    return __awaiter(this, void 0, void 0, function* () {
      return true;
    });
  }
  /**
   * @inheritDoc
   * @see ch.getLayout
   */
  getLayout() {
    return ch.getLayout();
  }
  getTitle() {
    const titleLocalizationItem = `${this.routeName}Page.Title`;
    const localizer = ServiceProvider.findLocalizer();
    return localizer != null && localizer.contains(titleLocalizationItem) ? localizer.get(titleLocalizationItem) : this.routeName;
  }
  /**
   * @inheritDoc
   * @see ch.getContext
   */
  getContext() {
    return ch.getContext();
  }
  getManualProps() {
    return {
      manual: this.getManual()
    };
  }
  /**
   * @inheritDoc
   * @return true
   */
  isPage() {
    return true;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide top navigation menu.
   * @return true
   */
  get hasTopNav() {
    return true;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide back button in the top navigation menu.
   * @return "mobile"
   */
  get hasBackButton() {
    return BackButtonVisibility.Mobile;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide left navigation menu.
   * @return true
   */
  get hasLeftNav() {
    return true;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide footer.
   * @return true
   */
  get hasFooter() {
    return true;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide top nav language selector.
   * @return true
   */
  get hasLanguageSelector() {
    return true;
  }
  get alert() {
    return ch.alert;
  }
  get routeName() {
    return this.props.routeName;
  }
  get routeIndex() {
    return this.props.routeIndex != null ? this.props.routeIndex : null;
  }
  get routeId() {
    return this.props.routeId != null ? this.props.routeId : null;
  }
  get parameters() {
    return this.props.parameters || null;
  }
  get route() {
    return new PageRoute(this.routeName, this.routeIndex, this.routeId, this.parameters);
  }
  get automaticUrlChange() {
    return !!this.props.automaticUrlChange;
  }
}

/**
 * Base class for all asynchronous components.
 */
class BaseAsyncComponent extends BaseComponent {
  constructor(props) {
    var _a;
    super(props);
    this._isAsync = (_a = props ? props.isAsync : null) !== null && _a !== void 0 ? _a : true;
  }
  /**
   * Fetch data via HTTP GET from the endpoint specified in {@link getEndpoint}.
   * @return Data returned by the endpoint.
   */
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const endpoint = this.getEndpoint();
      return yield this.getAsync(endpoint);
    });
  }
  /**
   * Reload the {@link BaseAsyncComponent}'s data if it is not already loaded or loading.
   * @param reload Should reload be forced if the data is already loaded.
   */
  invokeReloadDataAsync(reload = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.isAsync() && !this.isLoading && this.canReload()) {
        try {
          let state = this.state;
          if (reload || state.data == null) {
            state.isLoading = true;
            yield this.setState(state);
            const data = yield this.fetchDataAsync();
            state = this.state;
            state.data = data;
            yield this.processDataAsync(state, data);
            state.isLoading = false;
            if (this.isMounted) {
              yield this.setState(state);
            }
          }
        } catch (e) {
          if (this.isMounted) {
            yield this.setState({
              isLoading: false
            });
          }
          // @ts-ignore
          yield PageRouteProvider.exception(e);
        }
      }
    });
  }
  /**
   * Does nothing.
   */
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {});
  }
  /**
   * Does the {@link BaseAsyncComponent} have asynchronously loaded data.
   */
  get hasData() {
    return this.state.data != null;
  }
  /**
   * Can the {@link BaseAsyncComponent} be reloaded.
   * @return true
   */
  canReload() {
    return true;
  }
  /**
   * Call {@link reloadAsync} without awaiting.
   */
  reload() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.invokeReloadDataAsync(true);
  }
  // BaseComponent
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.invokeReloadDataAsync();
    });
  }
  /**
   * @inheritDoc
   *
   * NOTE: Can return true only if {@link hasSpinner} is overridden to return true.
   */
  isSpinning() {
    return this.hasSpinner() && (this.isLoading || super.isSpinning());
  }
  // IAsyncComponent
  isAsync() {
    return this._isAsync && this.getEndpoint().length > 0;
  }
  reloadAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeReloadDataAsync(true);
    });
  }
  get isLoading() {
    return this.state.isLoading;
  }
}

class StylesUtility {
  static textAlign(value) {
    switch (value) {
      case TextAlign.Left:
        return "left";
      case TextAlign.Center:
        return "center";
      case TextAlign.Right:
        return "right";
      default:
        return "initial";
    }
  }
  static verticalAlign(value) {
    switch (value) {
      case VerticalAlign.Top:
        return "top";
      case VerticalAlign.Middle:
        return "middle";
      case VerticalAlign.Bottom:
        return "bottom";
      default:
        return "initial";
    }
  }
}

class BaseComponentsLocalizer extends BaseLocalizer {
  constructor(supportedLanguages, language) {
    super(supportedLanguages, language);
  }
  getType() {
    return "IComponentsLocalizer";
  }
}
class BaseComponentLocalizer extends BaseLocalizer {
  constructor(supportedLanguages, language) {
    super(supportedLanguages, language);
    //private readonly _component: IBaseComponent;
    this._contextSupportedLanguages = null;
    this._contextSupportedLanguageCodes = null;
    this._contextDefaultLanguageCode = null;
    this._browserLanguageCode = null;
    this._applicationLocalizer = null;
    this._componentsLocalizer = null;
  }
  initialize(clear = false) {
    super.initialize(clear);
  }
  getApplicationLocalizer() {
    return this._applicationLocalizer || (this._applicationLocalizer = ServiceProvider.getService("ILocalizer"));
  }
  getComponentsLocalizer() {
    return this._componentsLocalizer || (this._componentsLocalizer = ServiceProvider.getService("IComponentsLocalizer"));
  }
  getSupportedLanguages() {
    if (this._contextSupportedLanguages) {
      return this._contextSupportedLanguages;
    }
    const applicationLocalizer = this.getApplicationLocalizer();
    this._contextSupportedLanguages = applicationLocalizer ? applicationLocalizer.supportedLanguages : super.getSupportedLanguages();
    return this._contextSupportedLanguages;
  }
  getSupportedLanguageCodes() {
    var _a;
    return (_a = this._contextSupportedLanguageCodes) !== null && _a !== void 0 ? _a : this._contextSupportedLanguageCodes = this.getSupportedLanguages().select(item => item.code);
  }
  getLanguage() {
    // Fetch component language
    const componentLanguage = super.getLanguage();
    // Fetch language from application localizer
    const applicationLocalizer = this.getApplicationLocalizer();
    const language = (applicationLocalizer === null || applicationLocalizer === void 0 ? void 0 : applicationLocalizer.language) || this.browserLanguageCode || this.getDefaultLanguage();
    if (language !== componentLanguage) {
      super.setLanguage(language);
    }
    return language;
  }
  getDefaultLanguage() {
    if (this._contextDefaultLanguageCode) {
      return this._contextDefaultLanguageCode;
    }
    const applicationLocalizer = this.getApplicationLocalizer();
    this._contextDefaultLanguageCode = applicationLocalizer ? applicationLocalizer.defaultLanguage : super.getDefaultLanguage();
    return this._contextDefaultLanguageCode;
  }
  get browserLanguageCode() {
    if (this._browserLanguageCode) {
      return this._browserLanguageCode;
    }
    const code = window.navigator.language.toLowerCase();
    const supportedLanguages = this.getSupportedLanguages();
    const supportedLanguage = supportedLanguages.find(item => item.code.toLowerCase() === code || item.label.toLowerCase() === code) || null;
    this._browserLanguageCode = supportedLanguage ? supportedLanguage.code : null;
    return this._browserLanguageCode;
  }
  getType() {
    return this.constructor.name;
  }
  get defaultLanguage() {
    return this.getDefaultLanguage();
  }
  get language() {
    return this.getLanguage();
  }
  get supportedLanguageCodes() {
    return this.getSupportedLanguageCodes();
  }
  getValue(language, name, ...params) {
    const applicationLocalizer = this.getApplicationLocalizer();
    if (applicationLocalizer != null && applicationLocalizer.contains(name)) {
      return applicationLocalizer.getValue(language, name, ...params);
    }
    const componentsLocalizer = this.getComponentsLocalizer();
    if (componentsLocalizer && componentsLocalizer.contains(name)) {
      return componentsLocalizer.getValue(language, name, ...params);
    }
    return super.getValue(language, name, ...params);
  }
  contains(name) {
    return super.contains(name);
  }
}

export { ActionType, AlertModel, AlertType, Align, ApiProvider, ArrayScope, BackButtonVisibility, BaseAsyncComponent, BaseComponent, BaseComponentLocalizer, BaseComponentsLocalizer, BaseInputType, BasePage, BasePageDefinitions, BasePageParameters, CameraType, ch as ComponentHelper, CountryInfo, DataStorageType, DescriptionModel, DialogResult, DocumentEventType, DocumentEventsProvider$1 as DocumentEventsProvider, DocumentPreviewModel, DocumentPreviewSize, ETagRequest, ETagResponse, InputValidationRule, JQueryUtility, Justify, LayoutBreak, LayoutType, LdData, LinkTarget, LocalizationString, LocalizationStringItem, MessageBoxButtons, MessageBoxIcon, PageCacheProvider, PageCacheTtl, PageRoute, PageRouteProvider, PasswordValidationError, PasswordValidationRule, ReactUtility, ServerError, StylesUtility, SwipeDirection, TextAlign, TokenData, TokenType, UserInteractionDataStorage$1 as UserInteractionDataStorage, VerticalAlign, WebApplicationType, ch };
